export const messages = {
    'zh-CN': {
        // 通用
        common: {
            all: '全部',
            confirm: '确定',
            cancel: '取消',
            search: '搜索',
            reset: '重置',
            submit: '提交',
            close: '关闭',
            back: '返回',
            refresh: '刷新',
            filter: '筛选',
            operation: '操作',
            success: '成功',
            error: '错误',
            warning: '警告',
            info: '提示',
            selectDate: '选择日期',
            pleaseSelect: '请选择',
            noData: '暂无数据',


            save: '保存',
            add: '新建',
            edit: '修改',
            delete: '删除',
            print: '打印',
            audit: '审核',
            cancelAudit: '取消审核',
            historyBill: '历史单据',

            export: '导出',
            import: '导入',
            importDetail: '导入明细',
            electronicScale: '电子秤',

            creator: '创建人',
            modifier: '修改人',
            createTime: '创建时间',
            modifyTime: '修改时间',
            auditor: '审核人',
            auditStatus: '审核状态',
            audited: '已审核',
            notAudited: '未审核',
            auditTime: '审核时间',

            label: '标签',
            barcodelabel: '条码标签',
            diyLabel: '自定义标签',
            rfidLabel: 'RFID',

            productDetail: '货品明细',
            accountDetail: '账款明细',
            paymentDetail: '收付款明细',

            allPriceSettlement: '全部结价',
            allMaterialSettlement: '全部结料',
            sequentialPriceSettlement: '依次结价',
            sequentialMaterialSettlement: '依次结料',

            billNo: '单号',
            billDate: '单据日期',
            billType: '单据类型',
            customer: '客户',
            counter: '柜台',
            salesman: '业务员',
            currency: '币别',
            handler: '经手人',
            store: '门店',
            remark: '备注',

            totalQty: '合计数量',
            totalAmt: '合计金额',
            priceSettledQty: '结价数量',
            materialSettledQty: '结料数量',
            payableAmt: '应付金额',
            unroundedAmt: '未抹零金额',
            totalWeight: '合计重量',
            totalNetGoldWeight: '合计折足重量',
            priceSettledWeight: '结价重量',
            materialSettledWeight: '结料重量',
            paidAmt: '已付金额',

            columnConfig: '列配置',
            displayedFields: '已显示字段',
            dragToReorder: '拖动可调整字段顺序',
            optionalFields: '可选字段',
            
            changePassword: '修改密码',
            oldPassword: '旧密码',
            newPassword: '新密码',
            confirmPassword: '再次输入密码',
            modify: '修改',
            logout: '退出登录',
            bindWechat: '绑定微信',
            
            // 导航菜单
            home: '首页',
            marketingManagement: '营销管理',
            accountManagement: '账款管理',
            dataAndSettings: '资料与设定',
            systemSettings: '系统设置',
            productionManagement: '生产管理',

            //标签导航
            closeAll:"关闭所有",
            closeOther:"关闭其他",
            scrollLeft:"向左滚动",
            scrollRight:"向左滚动",

            // 全屏提示
            fullscreen: '全屏',
            exitFullscreen: '取消全屏',
            unreadMessages: '有{count}条未读消息',
            noUnreadMessages: '暂无未读消息',
            
            // 消息提示
            bindSuccess: '绑定成功！',
            passwordModified: '修改成功',
            languageSwitched: '语言已切换为简体中文'
        },
        // 导航菜单翻译 - 按code_id
        navMenu: {
            '53': '公告列表',
            '131': '打印模板',
            '159': '打印模板初始化',
            '153': '表格列设置',
            '132': '工费取数优先级',
            '52': '操作日志',
            '51': '系统参数',
            '103': '单号规则管理',
            '133': '系统信息',
            '29': '柜台订购管理',
            '29000': '柜台订购管理历史列表',
            '30': '入库管理',
            '30000': '入库管理历史列表',
            '31': '出库管理',
            '31000': '出库管理历史列表',
            '108': '客退入库',
            '108000': '客退入库历史列表',
            '109': '退厂出库',
            '109000': '退厂出库历史列表',
            '176': '购销管理',
            '176000': '购销管理历史列表',
            '195': '定价回购结算',
            '195000': '定价回购结算历史列表',
            '198': '定价销售结算',
            '198000': '定价销售结算历史列表',
            '187': '旧料入库管理',
            '187000': '旧料入库管理历史列表',
            '184': '提纯发出管理',
            '184000': '提纯发出管理历史列表',
            '186': '提纯成色管理',
            '186000': '提纯成色管理历史列表',
            '185': '提纯收回管理',
            '185000': '提纯收回管理历史列表',
            '196': '委外加工出库',
            '196000': '委外加工出库历史列表',
            '197': '委外加工入库',
            '197000': '委外加工入库历史列表',
            '214': '粗料入库管理',
            '214000': '粗料入库管理历史列表',
            '215': '粗料出库管理',
            '215000': '粗料出库管理历史列表',
            '147': '分称管理',
            '147000': '分称管理历史列表',
            '154': '条码入库',
            '154000': '条码入库历史列表',
            '165': '条码销售出库',
            '165000': '条码销售出库历史列表',
            '166': '条码采购退货',
            '166000': '条码采购退货历史列表',
            '167': '条码销售退货',
            '167000': '条码销售退货历史列表',
            '210': '货品标签打印',
            '155': '金包银采购入库',
            '155000': '金包银采购入库历史列表',
            '156': '金包银销售出库',
            '156000': '金包银销售出库历史列表',
            '157': '金包银采购退货',
            '157000': '金包银采购退货历史列表',
            '158': '金包银销售退货',
            '158000': '金包银销售退货历史列表',
            '161': '金包银调拨结算',
            '161000': '金包银调拨结算历史列表',
            '32': '调拨管理',
            '32000': '调拨管理历史列表',
            '33': '库存调整管理',
            '33000': '库存调整管理历史列表',
            '148': '条码信息调整',
            '148000': '条码信息调整历史列表',
            '150': '条码履历',
            '151': '条码库存盘点',
            '151000': '条码库存盘点历史列表',
            '192': '国际贸易管理',
            '193': '加工贸易手册',
            '47': '综合报表',
            '46': '进销存表',
            '188': '金料提纯统计表',
            '209': '委外加工统计表',
            '45': '库存表',
            '112': '库存表-按品类',
            '212': '货号库存表',
            '213': '货号库存明细表',
            '152': '条码库存表',
            '160': '金包银库存表',
            '63': '订购明细表',
            '58': '调拨明细表',
            '146': '调拨汇总表',
            '48': '入库明细表',
            '115': '入库汇总表-按客户',
            '116': '入库汇总表-按产品',
            '54': '出库明细表',
            '118': '出库汇总表-按客户',
            '119': '出库汇总表-按业务员',
            '117': '出库汇总表-按产品',
            '120': '出入库单据明细表',
            '122': '出入库账款明细表',
            '190': '出入库单据列表',
            '162': '工费汇总表-按业务员',
            '34': '结价管理',
            '34000': '结价管理历史列表',
            '218': '存欠料账结价',
            '218000': '存欠料账结价历史列表',
            '174': '金料定价',
            '174000': '金料定价历史列表',
            '178': '金料定价结算',
            '178000': '金料定价结算历史列表',
            '194': '资产负债表',
            '35': '收款管理',
            '35000': '收款管理历史列表',
            '36': '付款管理',
            '36000': '付款管理历史列表',
            '90': '利息管理',
            '38': '账户过账',
            '37': '账款调整',
            '37000': '账款调整历史列表',
            '41': '货料调整',
            '41000': '货料调整历史列表',
            '42': '账户调整',
            '42000': '账户调整历史列表',
            '39': '货币转换',
            '39000': '货币转换历史列表',
            '40': '货料转换',
            '40000': '货料转换历史列表',
            '61': '综合报表',
            '200': '资产日报表',
            '123': '客户存欠总表-按客户',
            '124': '客户存欠总表-按业务员',
            '125': '客户存欠总表-按产品',
            '126': '客户对账单-按产品',
            '127': '客户对账单-按单据',
            '128': '账户收支明细表',
            '129': '结价明细表',
            '199': '结价汇总表-按产品',
            '134': '客户利息表',
            '135': '客户仓息表',
            '168': '素金利润表',
            '169': '素金销售利润表-按单据',
            '208': '素金销售结价利润表',
            '211': '素金成本明细表',
            '163': '条码工费利润表',
            '177': '条码销售利润表',
            '164': '金包银工费利润表',
            '170': '金包银销售利润表',
            '205': '配货销售利润表-按客户',
            '206': '配货销售利润表-按产品',
            '207': '配货销售利润表-按单据',
            '179': '持仓头寸统计表',
            '189': '定价明细表',
            '180': '定价结算明细表',
            '182': '定价未结明细表',
            '183': '定价未结汇总表-按产品',
            '201': '定价未结汇总表-按客户',
            '9': '类别列表',
            '10': '类别设定',
            '114': '单据类型',
            '149': '柜台管理',
            '171': '部门管理',
            '172': '账户管理',
            '173': '定价类型管理',
            '175': '金料定价方案',
            '191': '结算方式管理',
            '11': '员工管理',
            '14': '客户供应商管理',
            '121': '产品资料管理',
            '98': '门店管理',
            '22': '每日金价管理',
            '89': '利息方案管理',
            '13': '权限列表',
            '67': '客户工费',
            '130': '工费方案管理',
            '92': '库存分析',
            '102': '首页',
            '216': '费用项目管理',
            '219': '名词翻译管理',
            '220': '会员管理',
            '221': '会员标签管理',
            '222': '会员储值管理',
            '223': '会员储值流水表',
            '224': '会员续费管理',
            '225': '储值方案管理',
            '226': '条码组装管理',
            '226000': '条码组装历史单据',
            '227': '条码拆卸管理',
            '227000': '条码拆卸历史单据',
            '228': '提纯明细表',
            '229': '提纯日报表',
            '230': '购料日报表',
            '231': '汇总日报表'
        },
        translationNouns: {
            searchPlaceholder: '请输入搜索内容',
            index: '序号',
            zh_CN: '中文名词',
            zh_TW: '中文繁体',
            en: '英文',
            ja: '日语',
            ko: '韩语',
            fr: '法语',
            de: '德语',
            ru: '俄语',
            ar: '阿拉伯语',
            ms: '马来语',
            vi: '越南语',
            th: '泰语',
            hi: '印地语',
            confirmDelete: '确定要删除吗？',
            addSuccess: '添加成功',
            deleteSuccess: '删除成功',
            zh_CNRequired: '中文名词不能为空'
        }
    },
    'en': {
        // Common
        common: {
            all: 'ALL',
            confirm: 'Confirm',
            cancel: 'Cancel',
            search: 'Search',
            reset: 'Reset',
            print: 'Print',
            submit: 'Submit',
            close: 'Close',
            back: 'Back',
            refresh: 'Refresh',
            filter: 'Filter',
            operation: 'Operation',
            success: 'Success',
            error: 'Error',
            warning: 'Warning',
            info: 'Info',
            selectDate: 'Select Date',
            pleaseSelect: 'Please Select',
            noData: 'No Data',

            save: 'Save',
            add: 'Add',
            edit: 'Edit',
            delete: 'Delete',
            audit: 'Audit',
            cancelAudit: 'Cancel Audit',
            historyBill: 'History Bills',

            export: 'Export',
            import: 'Import',
            importDetail: 'Import Details',
            electronicScale: 'Electronic Scale',

            creator: 'Creator',
            modifier: 'Modifier',
            createTime: 'Create Time',
            modifyTime: 'Modify Time',
            auditor: 'Auditor',
            auditStatus: 'Audit Status',
            audited: 'Audited',
            notAudited: 'Not Audited',
            auditTime: 'Audit Time',

            label: 'Label',
            barcodelabel: 'Barcode Label',
            diyLabel: 'Custom Label',
            rfidLabel: 'RFID',

            productDetail: 'Product Details',
            accountDetail: 'Account Details',
            paymentDetail: 'Payment Details',

            allPriceSettlement: 'All Price Settlement',
            allMaterialSettlement: 'All Material Settlement',
            sequentialPriceSettlement: 'Sequential Price Settlement',
            sequentialMaterialSettlement: 'Sequential Material Settlement',

            billNo: 'Bill No.',
            billDate: 'Bill Date',
            billType: 'Bill Type',
            customer: 'Customer',
            counter: 'Counter',
            salesman: 'Salesman',
            currency: 'Currency',
            handler: 'Handler',
            store: 'Store',
            remark: 'Remark',

            totalQty: 'Total Quantity',
            totalAmt: 'Total Amount',
            priceSettledQty: 'Price Settled Qty',
            materialSettledQty: 'Material Settled Qty',
            payableAmt: 'Payable Amount',
            unroundedAmt: 'Unrounded Amount',
            totalWeight: 'Total Weight',
            totalNetGoldWeight: 'Total Net Gold Weight',
            priceSettledWeight: 'Price Settled Weight',
            materialSettledWeight: 'Material Settled Weight',
            paidAmt: 'Paid Amount',

            columnConfig: 'Column Configuration',
            displayedFields: 'Displayed Fields',
            dragToReorder: 'Drag to reorder fields',
            optionalFields: 'Optional Fields',
            
            changePassword: 'Change Password',
            oldPassword: 'Old Password',
            newPassword: 'New Password',
            confirmPassword: 'Confirm Password',
            modify: 'Modify',
            logout: 'Logout',
            bindWechat: 'Bind WeChat',
            
            // Navigation Menu
            home: 'Home',
            marketingManagement: 'Marketing',
            accountManagement: 'Accounts',
            dataAndSettings: 'Data Settings',
            systemSettings: 'System Settings',
            productionManagement: 'Production',

            closeAll:"Close ALL",
            closeOther:"Close Other",
            scrollLeft:"Scroll Left",
            scrollRight:"Scroll Right",

            // Fullscreen tooltip
            fullscreen: 'Fullscreen',
            exitFullscreen: 'Exit Fullscreen',
            unreadMessages: '{count} unread message(s)',
            noUnreadMessages: 'No unread messages',
            
            // Messages
            bindSuccess: 'Bind successful!',
            passwordModified: 'Password modified successfully',
            languageSwitched: 'Language switched to English'
        },
        // Navigation Menu Translation - by code_id
        navMenu: {
            '53': 'Notice List',
            '131': 'Print Template',
            '159': 'Print Template Init',
            '153': 'Table Column Settings',
            '132': 'Labor Fee Priority',
            '52': 'Operation Log',
            '51': 'System Parameters',
            '103': 'Bill No. Rule Management',
            '133': 'System Information',
            '29': 'Counter Order Management',
            '29000': 'Counter Order Management History',
            '30': 'Inbound Management',
            '30000': 'Inbound Management History',
            '31': 'Outbound Management',
            '31000': 'Outbound Management History',
            '108': 'Customer Return Inbound',
            '108000': 'Customer Return Inbound History',
            '109': 'Factory Return Outbound',
            '109000': 'Factory Return Outbound History',
            '176': 'Purchase & Sales Management',
            '176000': 'Purchase & Sales Management History',
            '195': 'Pricing Repurchase Settlement',
            '195000': 'Pricing Repurchase Settlement History',
            '198': 'Pricing Sales Settlement',
            '198000': 'Pricing Sales Settlement History',
            '187': 'Old Material Inbound',
            '187000': 'Old Material Inbound History',
            '184': 'Purification Dispatch',
            '184000': 'Purification Dispatch History',
            '186': 'Purification Quality',
            '186000': 'Purification Quality History',
            '185': 'Purification Recovery',
            '185000': 'Purification Recovery History',
            '196': 'Outsource Processing Outbound',
            '196000': 'Outsource Processing Outbound History',
            '197': 'Outsource Processing Inbound',
            '197000': 'Outsource Processing Inbound History',
            '214': 'Raw Material Inbound',
            '214000': 'Raw Material Inbound History',
            '215': 'Raw Material Outbound',
            '215000': 'Raw Material Outbound History',
            '147': 'Weight Separation',
            '147000': 'Weight Separation History',
            '154': 'Barcode Inbound',
            '154000': 'Barcode Inbound History',
            '165': 'Barcode Sales Outbound',
            '165000': 'Barcode Sales Outbound History',
            '166': 'Barcode Purchase Return',
            '166000': 'Barcode Purchase Return History',
            '167': 'Barcode Sales Return',
            '167000': 'Barcode Sales Return History',
            '210': 'Product Label Print',
            '155': 'Gold-Silver Inbound',
            '155000': 'Gold-Silver Inbound History',
            '156': 'Gold-Silver Outbound',
            '156000': 'Gold-Silver Outbound History',
            '157': 'Gold-Silver Purchase Return',
            '157000': 'Gold-Silver Purchase Return History',
            '158': 'Gold-Silver Sales Return',
            '158000': 'Gold-Silver Sales Return History',
            '161': 'Gold-Silver Transfer Settlement',
            '161000': 'Gold-Silver Transfer Settlement History',
            '32': 'Transfer Management',
            '32000': 'Transfer Management History',
            '33': 'Stock Adjustment',
            '33000': 'Stock Adjustment History',
            '148': 'Barcode Info Adjustment',
            '148000': 'Barcode Info Adjustment History',
            '150': 'Barcode History',
            '151': 'Barcode Stock Check',
            '151000': 'Barcode Stock Check History',
            '192': 'International Trade',
            '193': 'Processing Trade Manual',
            '47': 'Comprehensive Report',
            '46': 'Inventory Report',
            '188': 'Metal Purification Stats',
            '209': 'Outsource Processing Stats',
            '45': 'Stock Table',
            '112': 'Stock by Category',
            '212': 'Item No. Stock',
            '213': 'Item No. Stock Detail',
            '152': 'Barcode Stock',
            '160': 'Gold-Silver Stock',
            '63': 'Order Detail',
            '58': 'Transfer Detail',
            '146': 'Transfer Summary',
            '48': 'Inbound Detail',
            '115': 'Inbound Summary by Customer',
            '116': 'Inbound Summary by Product',
            '54': 'Outbound Detail',
            '118': 'Outbound Summary by Customer',
            '119': 'Outbound Summary by Salesman',
            '117': 'Outbound Summary by Product',
            '120': 'InOut Bill Detail',
            '122': 'InOut Account Detail',
            '190': 'InOut Bill List',
            '162': 'Labor Fee Summary by Salesman',
            '34': 'Price Settlement',
            '34000': 'Price Settlement History',
            '218': 'Metal Balance Settle',
            '218000': 'Metal Balance Settle History',
            '174': 'Metal Pricing',
            '174000': 'Metal Pricing History',
            '178': 'Metal Pricing Settlement',
            '178000': 'Metal Pricing Settlement History',
            '194': 'Balance Sheet',
            '35': 'Collection Management',
            '35000': 'Collection Management History',
            '36': 'Payment Management',
            '36000': 'Payment Management History',
            '90': 'Interest Management',
            '38': 'Account Posting',
            '37': 'Account Adjustment',
            '37000': 'Account Adjustment History',
            '41': 'Material Adjustment',
            '41000': 'Material Adjustment History',
            '42': 'Account Adjustment',
            '42000': 'Account Adjustment History',
            '39': 'Currency Conversion',
            '39000': 'Currency Conversion History',
            '40': 'Material Conversion',
            '40000': 'Material Conversion History',
            '61': 'Comprehensive Report',
            '200': 'Daily Asset Report',
            '123': 'Customer Balance by Customer',
            '124': 'Customer Balance by Salesman',
            '125': 'Customer Balance by Product',
            '126': 'Customer Statement by Product',
            '127': 'Customer Statement by Bill',
            '128': 'Account Income/Expense Detail',
            '129': 'Price Settlement Detail',
            '199': 'Price Settlement Summary by Product',
            '134': 'Customer Interest',
            '135': 'Customer Storage Interest',
            '168': 'Plain Gold Profit',
            '169': 'Plain Gold Sales Profit by Bill',
            '208': 'Plain Gold Sales Settlement Profit',
            '211': 'Plain Gold Cost Detail',
            '163': 'Barcode Labor Profit',
            '177': 'Barcode Sales Profit',
            '164': 'Gold-Silver Labor Profit',
            '170': 'Gold-Silver Sales Profit',
            '205': 'Distribution Sales Profit by Customer',
            '206': 'Distribution Sales Profit by Product',
            '207': 'Distribution Sales Profit by Bill',
            '179': 'Position Statistics',
            '189': 'Pricing Detail',
            '180': 'Pricing Settlement Detail',
            '182': 'Unsettled Pricing Detail',
            '183': 'Unsettled Pricing Summary by Product',
            '201': 'Unsettled Pricing Summary by Customer',
            '9': 'Category List',
            '10': 'Category Settings',
            '114': 'Bill Type',
            '149': 'Counter Management',
            '171': 'Department Management',
            '172': 'Account Management',
            '173': 'Pricing Type Management',
            '175': 'Metal Pricing Plan',
            '191': 'Settlement Method',
            '11': 'Staff Management',
            '14': 'Customer/Supplier Management',
            '121': 'Product Data Management',
            '98': 'Store Management',
            '22': 'Daily Gold Price',
            '89': 'Interest Scheme',
            '13': 'Permission List',
            '67': 'Customer Labor Fee',
            '130': 'Labor Fee Scheme',
            '92': 'Stock Analysis',
            '102': 'Home',
            '216': 'Expense Project Manage',
            '219': 'Term Translation Management',
            '220': 'Member Management',
            '221': 'Member Tag Management',
            '222': 'Member Stored Value Management',
            '223': 'Member Stored Value Transaction Report',
            '224': 'Member Renewal Management',
            '225': 'Stored Value Plan Management',
            '226': 'Barcode Assembly Management',
            '226000': 'Barcode Assembly History Bills',
            '227': 'Barcode Disassembly Management',
            '227000': 'Barcode Disassembly History Bills',
            '228': 'Purify Detail Report',
            '229': 'Purify Daily Report',
            '230': 'Purchase Daily Report',
            '231': 'Summary Daily Report'
        },
        translationNouns: {
            searchPlaceholder: 'Enter search content',
            index: 'No.',
            zh_CN: 'Chinese',
            zh_TW: 'Chinese Traditional',
            en: 'English',
            ja: 'Japanese',
            ko: 'Korean',
            fr: 'French',
            de: 'German',
            ru: 'Russian',
            ar: 'Arabic',
            ms: 'Malay',
            vi: 'Vietnamese',
            th: 'Thai',
            hi: 'Hindi',
            confirmDelete: 'Are you sure to delete?',
            addSuccess: 'Added successfully',
            deleteSuccess: 'Deleted successfully',
            zh_CNRequired: 'Chinese noun is required'
        }
    },
    'zh-TW': {
        // 通用
        common: {
            all: '全部',
            confirm: '確定',
            cancel: '取消',
            search: '搜尋',
            reset: '重置',
            print: '列印',
            submit: '提交',
            close: '關閉',
            back: '返回',
            refresh: '刷新',
            filter: '篩選',
            operation: '操作',
            success: '成功',
            error: '錯誤',
            warning: '警告',
            info: '提示',
            selectDate: '選擇日期',
            pleaseSelect: '請選擇',
            noData: '暫無資料',

            save: '保存',
            add: '新建',
            edit: '修改',
            delete: '刪除',
            audit: '審核',
            cancelAudit: '取消審核',
            historyBill: '歷史單據',

            export: '匯出',
            import: '匯入',
            importDetail: '匯入明細',
            electronicScale: '電子秤',

            creator: '創建人',
            modifier: '修改人',
            createTime: '創建時間',
            modifyTime: '修改時間',
            auditor: '審核人',
            auditStatus: '審核狀態',
            audited: '已審核',
            notAudited: '未審核',
            auditTime: '審核時間',

            label: '標籤',
            barcodelabel: '條碼標籤',
            diyLabel: '自定義標籤',
            rfidLabel: 'RFID',

            productDetail: '貨品明細',
            accountDetail: '帳款明細',
            paymentDetail: '收付款明細',

            allPriceSettlement: '全部結價',
            allMaterialSettlement: '全部結料',
            sequentialPriceSettlement: '依次結價',
            sequentialMaterialSettlement: '依次結料',

            billNo: '單號',
            billDate: '單據日期',
            billType: '單據類型',
            customer: '客戶',
            counter: '櫃台',
            salesman: '業務員',
            currency: '幣別',
            handler: '經手人',
            store: '門店',
            remark: '備註',

            totalQty: '合計數量',
            totalAmt: '合計金額',
            priceSettledQty: '結價數量',
            materialSettledQty: '結料數量',
            payableAmt: '應付金額',
            unroundedAmt: '未抹零金額',
            totalWeight: '合計重量',
            totalNetGoldWeight: '合計折足重量',
            priceSettledWeight: '結價重量',
            materialSettledWeight: '結料重量',
            paidAmt: '已付金額',

            columnConfig: '欄位配置',
            displayedFields: '已顯示欄位',
            dragToReorder: '拖動可調整欄位順序',
            optionalFields: '可選欄位',
            
            changePassword: '修改密碼',
            oldPassword: '舊密碼',
            newPassword: '新密碼',
            confirmPassword: '再次輸入密碼',
            modify: '修改',
            logout: '退出登錄',
            bindWechat: '綁定微信',
            
            // 導航菜單
            home: '首頁',
            marketingManagement: '營銷管理',
            accountManagement: '賬款管理',
            dataAndSettings: '資料與設定',
            systemSettings: '系統設置',
            productionManagement: '生產管理',

            closeAll:"關閉所有",
            closeOther:"關閉其他",
            scrollLeft:"向左滾動",
            scrollRight:"向右滾動",
            
            // 全屏提示
            fullscreen: '全屏',
            exitFullscreen: '取消全屏',
            unreadMessages: '有{count}條未讀消息',
            noUnreadMessages: '暫無未讀消息',
            
            // 消息提示
            bindSuccess: '綁定成功！',
            passwordModified: '修改成功',
            languageSwitched: '語言已切換為繁體中文'
        },
        // 導航菜單翻譯 - 按code_id
        navMenu: {
            '53': '公告列表',
            '131': '列印模板',
            '159': '列印模板初始化',
            '153': '表格欄位設置',
            '132': '工費取數優先級',
            '52': '操作日誌',
            '51': '系統參數',
            '103': '單號規則管理',
            '133': '系統信息',
            '29': '櫃台訂購管理',
            '29000': '櫃台訂購管理歷史列表',
            '30': '入庫管理',
            '30000': '入庫管理歷史列表',
            '31': '出庫管理',
            '31000': '出庫管理歷史列表',
            '108': '客退入庫',
            '108000': '客退入庫歷史列表',
            '109': '退廠出庫',
            '109000': '退廠出庫歷史列表',
            '176': '購銷管理',
            '176000': '購銷管理歷史列表',
            '195': '定價回購結算',
            '195000': '定價回購結算歷史列表',
            '198': '定價銷售結算',
            '198000': '定價銷售結算歷史列表',
            '187': '舊料入庫管理',
            '187000': '舊料入庫管理歷史列表',
            '184': '提純發出管理',
            '184000': '提純發出管理歷史列表',
            '186': '提純成色管理',
            '186000': '提純成色管理歷史列表',
            '185': '提純收回管理',
            '185000': '提純收回管理歷史列表',
            '196': '委外加工出庫',
            '196000': '委外加工出庫歷史列表',
            '197': '委外加工入庫',
            '197000': '委外加工入庫歷史列表',
            '214': '粗料入庫管理',
            '214000': '粗料入庫管理歷史列表',
            '215': '粗料出庫管理',
            '215000': '粗料出庫管理歷史列表',
            '147': '分稱管理',
            '147000': '分稱管理歷史列表',
            '154': '條碼入庫',
            '154000': '條碼入庫歷史列表',
            '165': '條碼銷售出庫',
            '165000': '條碼銷售出庫歷史列表',
            '166': '條碼採購退貨',
            '166000': '條碼採購退貨歷史列表',
            '167': '條碼銷售退貨',
            '167000': '條碼銷售退貨歷史列表',
            '210': '貨品標籤列印',
            '155': '金包銀採購入庫',
            '155000': '金包銀採購入庫歷史列表',
            '156': '金包銀銷售出庫',
            '156000': '金包銀銷售出庫歷史列表',
            '157': '金包銀採購退貨',
            '157000': '金包銀採購退貨歷史列表',
            '158': '金包銀銷售退貨',
            '158000': '金包銀銷售退貨歷史列表',
            '161': '金包銀調撥結算',
            '161000': '金包銀調撥結算歷史列表',
            '32': '調撥管理',
            '000': '調撥管理歷史列表',
            '33': '庫存調整管理',
            '33000': '庫存調整管理歷史列表',
            '148': '條碼信息調整',
            '148000': '條碼信息調整歷史列表',
            '150': '條碼履歷',
            '151': '條碼庫存盤點',
            '151000': '條碼庫存盤點歷史列表',
            '192': '國際貿易管理',
            '193': '加工貿易手冊',
            '47': '綜合報表',
            '46': '進銷存表',
            '188': '金料提純統計表',
            '209': '委外加工統計表',
            '45': '庫存表',
            '112': '庫存表-按品類',
            '212': '貨號庫存表',
            '213': '貨號庫存明細表',
            '152': '條碼庫存表',
            '160': '金包銀庫存表',
            '63': '訂購明細表',
            '58': '調撥明細表',
            '146': '調撥匯總表',
            '48': '入庫明細表',
            '115': '入庫匯總表-按客戶',
            '116': '入庫匯總表-按產品',
            '54': '出庫明細表',
            '118': '出庫匯總表-按客戶',
            '119': '出庫匯總表-按業務員',
            '117': '出庫匯總表-按產品',
            '120': '出入庫單據明細表',
            '122': '出入庫賬款明細表',
            '190': '出入庫單據列表',
            '162': '工費匯總表-按業務員',
            '34': '結價管理',
            '34000': '結價管理歷史列表',
            '218': '存欠料賬結價',
            '218000': '存欠料賬結價历史列表',
            '174': '金料定價',
            '174000': '金料定價歷史列表',
            '178': '金料定價結算',
            '178000': '金料定價結算歷史列表',
            '194': '資產負債表',
            '35': '收款管理',
            '35000': '收款管理歷史列表',
            '36': '付款管理',
            '36000': '付款管理歷史列表',
            '90': '利息管理',
            '38': '賬戶過賬',
            '37': '賬款調整',
            '37000': '賬款調整歷史列表',
            '41': '貨料調整',
            '41000': '貨料調整歷史列表',
            '42': '賬戶調整',
            '42000': '賬戶調整歷史列表',
            '39': '貨幣轉換',
            '39000': '貨幣轉換歷史列表',
            '40': '貨料轉換',
            '40000': '貨料轉換歷史列表',
            '61': '綜合報表',
            '200': '資產日報表',
            '123': '客戶存欠總表-按客戶',
            '124': '客戶存欠總表-按業務員',
            '125': '客戶存欠總表-按產品',
            '126': '客戶對賬單-按產品',
            '127': '客戶對賬單-按單據',
            '128': '賬戶收支明細表',
            '129': '結價明細表',
            '199': '結價匯總表-按產品',
            '134': '客戶利息表',
            '135': '客戶倉息表',
            '168': '素金利潤表',
            '169': '素金銷售利潤表-按單據',
            '208': '素金銷售結價利潤表',
            '211': '素金成本明細表',
            '163': '條碼工費利潤表',
            '177': '條碼銷售利潤表',
            '164': '金包銀工費利潤表',
            '170': '金包銀銷售利潤表',
            '205': '配貨銷售利潤表-按客戶',
            '206': '配貨銷售利潤表-按產品',
            '207': '配貨銷售利潤表-按單據',
            '179': '持倉頭寸統計表',
            '189': '定價明細表',
            '180': '定價結算明細表',
            '182': '定價未結明細表',
            '183': '定價未結匯總表-按產品',
            '201': '定價未結匯總表-按客戶',
            '9': '類別列表',
            '10': '類別設定',
            '114': '單據類型',
            '149': '櫃台管理',
            '171': '部門管理',
            '172': '賬戶管理',
            '173': '定價類型管理',
            '175': '金料定價方案',
            '191': '結算方式管理',
            '11': '員工管理',
            '14': '客戶供應商管理',
            '121': '產品資料管理',
            '98': '門店管理',
            '22': '每日金價管理',
            '89': '利息方案管理',
            '13': '權限列表',
            '67': '客戶工費',
            '130': '工費方案管理',
            '92': '庫存分析',
            '102': '首頁',
            '216': '費用項目管理',
            '219': '名詞翻譯管理',
            '220': '會員管理',
            '221': '會員標籤管理',
            '222': '會員儲值管理',
            '223': '會員儲值流水表',
            '224': '會員續費管理',
            '225': '儲值方案管理',
            '226': '條碼組裝管理',
            '226000': '條碼組裝歷史單據',
            '227': '條碼拆卸管理',
            '227000': '條碼拆卸歷史單據',
            '228': '提純明細表',
            '229': '提純日報表'
        },
        translationNouns: {
            searchPlaceholder: '請輸入搜尋內容',
            index: '序號',
            zh_CN: '中文名詞',
            zh_TW: '中文繁體',
            en: '英文',
            ja: '日語',
            ko: '韓語',
            fr: '法語',
            de: '德語',
            ru: '俄語',
            ar: '阿拉伯語',
            ms: '馬來語',
            vi: '越南語',
            th: '泰語',
            hi: '印地語',
            confirmDelete: '確定要刪除嗎？',
            addSuccess: '新增成功',
            deleteSuccess: '刪除成功',
            zh_CNRequired: '中文名詞不能為空'
        }
    },
    'ja': {
        // 共通
        common: {
            all: '全部',
            confirm: '確認',
            cancel: 'キャンセル',
            search: '検索',
            reset: 'リセット',
            submit: '提出',
            close: '閉じる',
            back: '戻る',
            refresh: '更新',
            filter: 'フィルター',
            operation: '操作',
            success: '成功',
            error: 'エラー',
            warning: '警告',
            info: 'ヒント',
            selectDate: '日付を選択',
            pleaseSelect: '選択してください',
            noData: 'データなし',

            save: '保存',
            add: '新規作成',
            edit: '修正',
            delete: '削除',
            print: '印刷',
            audit: '承認',
            cancelAudit: '承認取消',
            historyBill: '履歴伝票',

            export: 'エクスポート',
            import: 'インポート',
            importDetail: 'インポート明細',
            electronicScale: '電子計量器',

            creator: '作成者',
            modifier: '修正者',
            createTime: '作成日時',
            modifyTime: '修正日時',
            auditor: '承認者',
            auditStatus: '承認ステータス',
            audited: '承認済',
            notAudited: '未承認',
            auditTime: '承認日時',

            label: 'ラベル',
            barcodelabel: 'バーコードラベル',
            diyLabel: 'カスタムラベル',
            rfidLabel: 'RFID',

            productDetail: '商品明細',
            accountDetail: '勘定明細',
            paymentDetail: '収払明細',

            allPriceSettlement: '一括価格決済',
            allMaterialSettlement: '一括素材決済',
            sequentialPriceSettlement: '順次価格決済',
            sequentialMaterialSettlement: '順次素材決済',

            billNo: '伝票番号',
            billDate: '伝票日付',
            billType: '伝票種類',
            customer: '顧客',
            counter: 'カウンター',
            salesman: '営業担当',
            currency: '通貨',
            handler: '取扱者',
            store: '店舗',
            remark: '備考',

            totalQty: '合計数量',
            totalAmt: '合計金額',
            priceSettledQty: '価格決済数量',
            materialSettledQty: '素材決済数量',
            payableAmt: '支払金額',
            unroundedAmt: '端数切捨て前金額',
            totalWeight: '合計重量',
            totalNetGoldWeight: '合計純金重量',
            priceSettledWeight: '価格決済重量',
            materialSettledWeight: '素材決済重量',
            paidAmt: '支払済金額',

            columnConfig: '列設定',
            displayedFields: '表示中のフィールド',
            dragToReorder: 'ドラッグでフィールド順序を変更',
            optionalFields: 'オプションフィールド',
            
            changePassword: 'パスワード変更',
            oldPassword: '旧パスワード',
            newPassword: '新パスワード',
            confirmPassword: 'パスワード確認',
            modify: '修正',
            logout: 'ログアウト',
            bindWechat: 'WeChatバインド',
            
            // ナビゲーションメニュー
            home: 'ホーム',
            marketingManagement: 'マーケティング管理',
            accountManagement: '勘定管理',
            dataAndSettings: 'データと設定',
            systemSettings: 'システム設定',
            productionManagement: '生産管理',

            closeAll: 'すべて閉じる',
            closeOther: 'その他を閉じる',
            scrollLeft: '左にスクロール',
            scrollRight: '右にスクロール',

            fullscreen: '全画面',
            exitFullscreen: '全画面解除',
            unreadMessages: '{count}件の未読メッセージ',
            noUnreadMessages: '未読メッセージなし',
            
            bindSuccess: 'バインド成功！',
            passwordModified: 'パスワード変更成功',
            languageSwitched: '言語が日本語に切り替わりました'
        },
        navMenu: {
            '53': 'お知らせ一覧',
            '131': '印刷テンプレート',
            '159': '印刷テンプレート初期化',
            '153': 'テーブル列設定',
            '132': '工費データ優先度',
            '52': '操作ログ',
            '51': 'システムパラメータ',
            '103': '伝票番号ルール管理',
            '133': 'システム情報',
            '29': 'カウンター注文管理',
            '29000': 'カウンター注文管理履歴',
            '30': '入庫管理',
            '30000': '入庫管理履歴',
            '31': '出庫管理',
            '31000': '出庫管理履歴',
            '108': '顧客返品入庫',
            '108000': '顧客返品入庫履歴',
            '109': '工場返品出庫',
            '109000': '工場返品出庫履歴',
            '176': '売買管理',
            '176000': '売買管理履歴',
            '195': '価格設定買戻決済',
            '195000': '価格設定買戻決済履歴',
            '198': '価格設定販売決済',
            '198000': '価格設定販売決済履歴',
            '187': '旧素材入庫管理',
            '187000': '旧素材入庫管理履歴',
            '184': '精錬発送管理',
            '184000': '精錬発送管理履歴',
            '186': '精錬品位管理',
            '186000': '精錬品位管理履歴',
            '185': '精錬回収管理',
            '185000': '精錬回収管理履歴',
            '196': '外注加工出庫',
            '196000': '外注加工出庫履歴',
            '197': '外注加工入庫',
            '197000': '外注加工入庫履歴',
            '214': '粗素材入庫管理',
            '214000': '粗素材入庫管理履歴',
            '215': '粗素材出庫管理',
            '215000': '粗素材出庫管理履歴',
            '147': '重量分割管理',
            '147000': '重量分割管理履歴',
            '154': 'バーコード入庫',
            '154000': 'バーコード入庫履歴',
            '165': 'バーコード販売出庫',
            '165000': 'バーコード販売出庫履歴',
            '166': 'バーコード購入返品',
            '166000': 'バーコード購入返品履歴',
            '167': 'バーコード販売返品',
            '167000': 'バーコード販売返品履歴',
            '210': '商品ラベル印刷',
            '155': '金銀メッキ入庫',
            '155000': '金銀メッキ入庫履歴',
            '156': '金銀メッキ出庫',
            '156000': '金銀メッキ出庫履歴',
            '157': '金銀メッキ購入返品',
            '157000': '金銀メッキ購入返品履歴',
            '158': '金銀メッキ販売返品',
            '158000': '金銀メッキ販売返品履歴',
            '161': '金銀メッキ振替決済',
            '161000': '金銀メッキ振替決済履歴',
            '32': '振替管理',
            '32000': '振替管理履歴',
            '33': '在庫調整管理',
            '33000': '在庫調整管理履歴',
            '148': 'バーコード情報調整',
            '148000': 'バーコード情報調整履歴',
            '150': 'バーコード履歴',
            '151': 'バーコード在庫棚卸',
            '151000': 'バーコード在庫棚卸履歴',
            '192': '国際貿易管理',
            '193': '加工貿易手帳',
            '47': '総合レポート',
            '46': '出入庫表',
            '188': '金素材精錬統計表',
            '209': '外注加工統計表',
            '45': '在庫表',
            '112': '在庫表-カテゴリ別',
            '212': '商品番号在庫表',
            '213': '商品番号在庫明細表',
            '152': 'バーコード在庫表',
            '160': '金銀メッキ在庫表',
            '63': '注文明細表',
            '58': '振替明細表',
            '146': '振替汇总表',
            '48': '入庫明細表',
            '115': '入庫汇总表-顧客別',
            '116': '入庫汇总表-商品別',
            '54': '出庫明細表',
            '118': '出庫汇总表-顧客別',
            '119': '出庫汇总表-営業担当別',
            '117': '出庫汇总表-商品別',
            '120': '出入庫伝票明細表',
            '122': '出入庫勘定明細表',
            '190': '出入庫伝票一覧',
            '162': '工費汇总表-営業担当別',
            '34': '価格決済管理',
            '34000': '価格決済管理履歴',
            '218': '素材在庫決済',
            '218000': '素材在庫決済履歴',
            '174': '金素材価格設定',
            '174000': '金素材価格設定履歴',
            '178': '金素材価格決済',
            '178000': '金素材価格決済履歴',
            '194': '貸借対照表',
            '35': '入金管理',
            '35000': '入金管理履歴',
            '36': '出金管理',
            '36000': '出金管理履歴',
            '90': '利息管理',
            '38': '勘定振替',
            '37': '勘定調整',
            '37000': '勘定調整履歴',
            '41': '素材調整',
            '41000': '素材調整履歴',
            '42': '口座調整',
            '42000': '口座調整履歴',
            '39': '通貨変換',
            '39000': '通貨変換履歴',
            '40': '素材変換',
            '40000': '素材変換履歴',
            '61': '総合レポート',
            '200': '資産日報',
            '123': '顧客在庫表-顧客別',
            '124': '顧客在庫表-営業担当別',
            '125': '顧客在庫表-商品別',
            '126': '顧客照合表-商品別',
            '127': '顧客照合表-伝票別',
            '128': '口座収支明細表',
            '129': '価格決済明細表',
            '199': '価格決済汇总表-商品別',
            '134': '顧客利息表',
            '135': '顧客倉庫利息表',
            '168': '純金利益表',
            '169': '純金販売利益表-伝票別',
            '208': '純金販売決済利益表',
            '211': '純金コスト明細表',
            '163': 'バーコード工費利益表',
            '177': 'バーコード販売利益表',
            '164': '金銀メッキ工費利益表',
            '170': '金銀メッキ販売利益表',
            '205': '配荷販売利益表-顧客別',
            '206': '配荷販売利益表-商品別',
            '207': '配荷販売利益表-伝票別',
            '179': 'ポジション統計表',
            '189': '価格設定明細表',
            '180': '価格設定決済明細表',
            '182': '価格設定未決済明細表',
            '183': '価格設定未決済汇总表-商品別',
            '201': '価格設定未決済汇总表-顧客別',
            '9': 'カテゴリ一覧',
            '10': 'カテゴリ設定',
            '114': '伝票種類',
            '149': 'カウンター管理',
            '171': '部門管理',
            '172': '口座管理',
            '173': '価格設定タイプ管理',
            '175': '金素材価格設定方案',
            '191': '決済方法管理',
            '11': '従業員管理',
            '14': '顧客サプライヤー管理',
            '121': '商品データ管理',
            '98': '店舗管理',
            '22': '毎日金価格管理',
            '89': '利息スキーム管理',
            '13': '権限一覧',
            '67': '顧客工費',
            '130': '工費スキーム管理',
            '92': '在庫分析',
            '102': 'ホーム',
            '216': '費用プロジェクト管理',
            '219': '用語翻訳管理',
            '220': '会員管理',
            '221': '会員タグ管理',
            '222': '会員储值管理',
            '223': '会員储值明細表',
            '224': '会員更新管理',
            '225': 'チャージプラン管理',
            '226': 'バーコード組立管理',
            '226000': 'バーコード組立履歴伝票',
            '227': 'バーコード分解管理',
            '227000': 'バーコード分解履歴伝票',
            '228': '精製明細表',
            '229': '精製日報表'
        },
        translationNouns: {
            searchPlaceholder: '検索内容を入力してください',
            index: '番号',
            zh_CN: '中国語',
            zh_TW: '繁体字中国語',
            en: '英語',
            ja: '日本語',
            ko: '韓国語',
            fr: 'フランス語',
            de: 'ドイツ語',
            ru: 'ロシア語',
            ar: 'アラビア語',
            ms: 'マレー語',
            vi: 'ベトナム語',
            th: 'タイ語',
            hi: 'ヒンディー語',
            confirmDelete: '削除してもよろしいですか？',
            addSuccess: '追加成功',
            deleteSuccess: '削除成功',
            zh_CNRequired: '中国語名詞は必須です'
        }
    },
    'ko': {
        // 공통
        common: {
            all: '전체',
            confirm: '확인',
            cancel: '취소',
            search: '검색',
            reset: '초기화',
            submit: '제출',
            close: '닫기',
            back: '돌아가기',
            refresh: '새로고침',
            filter: '필터',
            operation: '작업',
            success: '성공',
            error: '오류',
            warning: '경고',
            info: '알림',
            selectDate: '날짜 선택',
            pleaseSelect: '선택해주세요',
            noData: '데이터 없음',

            save: '저장',
            add: '신규 작성',
            edit: '수정',
            delete: '삭제',
            print: '인쇄',
            audit: '승인',
            cancelAudit: '승인 취소',
            historyBill: '이력 전표',

            export: '내보내기',
            import: '가져오기',
            importDetail: '가져오기 명세',
            electronicScale: '전자 저울',

            creator: '작성자',
            modifier: '수정자',
            createTime: '작성 시간',
            modifyTime: '수정 시간',
            auditor: '승인자',
            auditStatus: '승인 상태',
            audited: '승인됨',
            notAudited: '미승인',
            auditTime: '승인 시간',

            label: '라벨',
            barcodelabel: '바코드 라벨',
            diyLabel: '사용자 정의 라벨',
            rfidLabel: 'RFID',

            productDetail: '상품 명세',
            accountDetail: '계정 명세',
            paymentDetail: '수불 명세',

            allPriceSettlement: '일괄 가격 정산',
            allMaterialSettlement: '일괄 자재 정산',
            sequentialPriceSettlement: '순차 가격 정산',
            sequentialMaterialSettlement: '순차 자재 정산',

            billNo: '전표 번호',
            billDate: '전표 날짜',
            billType: '전표 종류',
            customer: '고객',
            counter: '카운터',
            salesman: '영업 담당',
            currency: '통화',
            handler: '담당자',
            store: '매장',
            remark: '비고',

            totalQty: '합계 수량',
            totalAmt: '합계 금액',
            priceSettledQty: '가격 정산 수량',
            materialSettledQty: '자재 정산 수량',
            payableAmt: '지불 금액',
            unroundedAmt: '미반올림 금액',
            totalWeight: '합계 중량',
            totalNetGoldWeight: '합계 순금 중량',
            priceSettledWeight: '가격 정산 중량',
            materialSettledWeight: '자재 정산 중량',
            paidAmt: '지불 완료 금액',

            columnConfig: '열 설정',
            displayedFields: '표시 중인 필드',
            dragToReorder: '드래그하여 필드 순서 변경',
            optionalFields: '선택 필드',
            
            changePassword: '비밀번호 변경',
            oldPassword: '기존 비밀번호',
            newPassword: '새 비밀번호',
            confirmPassword: '비밀번호 확인',
            modify: '수정',
            logout: '로그아웃',
            bindWechat: 'WeChat 연동',
            
            // 내비게이션 메뉴
            home: '홈',
            marketingManagement: '마케팅 관리',
            accountManagement: '계정 관리',
            dataAndSettings: '데이터 및 설정',
            systemSettings: '시스템 설정',
            productionManagement: '생산 관리',

            closeAll: '모두 닫기',
            closeOther: '기타 닫기',
            scrollLeft: '왼쪽으로 스크롤',
            scrollRight: '오른쪽으로 스크롤',

            fullscreen: '전체 화면',
            exitFullscreen: '전체 화면 해제',
            unreadMessages: '{count}건의 읽지 않은 메시지',
            noUnreadMessages: '읽지 않은 메시지 없음',
            
            bindSuccess: '연동 성공!',
            passwordModified: '비밀번호 변경 성공',
            languageSwitched: '언어가 한국어로 변경되었습니다'
        },
        navMenu: {
            '53': '공지 목록',
            '131': '인쇄 템플릿',
            '159': '인쇄 템플릿 초기화',
            '153': '테이블 열 설정',
            '132': '공임 데이터 우선순위',
            '52': '작업 로그',
            '51': '시스템 매개변수',
            '103': '전표 번호 규칙 관리',
            '133': '시스템 정보',
            '29': '카운터 주문 관리',
            '29000': '카운터 주문 관리 이력',
            '30': '입고 관리',
            '30000': '입고 관리 이력',
            '31': '출고 관리',
            '31000': '출고 관리 이력',
            '108': '고객 반품 입고',
            '108000': '고객 반품 입고 이력',
            '109': '공장 반품 출고',
            '109000': '공장 반품 출고 이력',
            '176': '매매 관리',
            '176000': '매매 관리 이력',
            '195': '가격 설정 매입 정산',
            '195000': '가격 설정 매입 정산 이력',
            '198': '가격 설정 판매 정산',
            '198000': '가격 설정 판매 정산 이력',
            '187': '구 자재 입고 관리',
            '187000': '구 자재 입고 관리 이력',
            '184': '정제 발송 관리',
            '184000': '정제 발송 관리 이력',
            '186': '정제 순도 관리',
            '186000': '정제 순도 관리 이력',
            '185': '정제 회수 관리',
            '185000': '정제 회수 관리 이력',
            '196': '외주 가공 출고',
            '196000': '외주 가공 출고 이력',
            '197': '외주 가공 입고',
            '197000': '외주 가공 입고 이력',
            '214': '원자재 입고 관리',
            '214000': '원자재 입고 관리 이력',
            '215': '원자재 출고 관리',
            '215000': '원자재 출고 관리 이력',
            '147': '중량 분할 관리',
            '147000': '중량 분할 관리 이력',
            '154': '바코드 입고',
            '154000': '바코드 입고 이력',
            '165': '바코드 판매 출고',
            '165000': '바코드 판매 출고 이력',
            '166': '바코드 구매 반품',
            '166000': '바코드 구매 반품 이력',
            '167': '바코드 판매 반품',
            '167000': '바코드 판매 반품 이력',
            '210': '상품 라벨 인쇄',
            '155': '금은 도금 입고',
            '155000': '금은 도금 입고 이력',
            '156': '금은 도금 출고',
            '156000': '금은 도금 출고 이력',
            '157': '금은 도금 구매 반품',
            '157000': '금은 도금 구매 반품 이력',
            '158': '금은 도금 판매 반품',
            '158000': '금은 도금 판매 반품 이력',
            '161': '금은 도금 이체 정산',
            '161000': '금은 도금 이체 정산 이력',
            '32': '이체 관리',
            '32000': '이체 관리 이력',
            '33': '재고 조정 관리',
            '33000': '재고 조정 관리 이력',
            '148': '바코드 정보 조정',
            '148000': '바코드 정보 조정 이력',
            '150': '바코드 이력',
            '151': '바코드 재고 실사',
            '151000': '바코드 재고 실사 이력',
            '192': '국제 무역 관리',
            '193': '가공 무역 수첩',
            '47': '종합 보고서',
            '46': '입출고표',
            '188': '금 소재 정제 통계표',
            '209': '외주 가공 통계표',
            '45': '재고표',
            '112': '재고표-카테고리별',
            '212': '상품번호 재고표',
            '213': '상품번호 재고 명세표',
            '152': '바코드 재고표',
            '160': '금은 도금 재고표',
            '63': '주문 명세표',
            '58': '이체 명세표',
            '146': '이체 집계표',
            '48': '입고 명세표',
            '115': '입고 집계표-고객별',
            '116': '입고 집계표-상품별',
            '54': '출고 명세표',
            '118': '출고 집계표-고객별',
            '119': '출고 집계표-영업담당별',
            '117': '출고 집계표-상품별',
            '120': '입출고 전표 명세표',
            '122': '입출고 계정 명세표',
            '190': '입출고 전표 목록',
            '162': '공임 집계표-영업담당별',
            '34': '가격 정산 관리',
            '34000': '가격 정산 관리 이력',
            '218': '자재 재고 정산',
            '218000': '자재 재고 정산 이력',
            '174': '금 소재 가격 설정',
            '174000': '금 소재 가격 설정 이력',
            '178': '금 소재 가격 정산',
            '178000': '금 소재 가격 정산 이력',
            '194': '대차대조표',
            '35': '입금 관리',
            '35000': '입금 관리 이력',
            '36': '출금 관리',
            '36000': '출금 관리 이력',
            '90': '이자 관리',
            '38': '계정 대체',
            '37': '계정 조정',
            '37000': '계정 조정 이력',
            '41': '자재 조정',
            '41000': '자재 조정 이력',
            '42': '계좌 조정',
            '42000': '계좌 조정 이력',
            '39': '통화 변환',
            '39000': '통화 변환 이력',
            '40': '자재 변환',
            '40000': '자재 변환 이력',
            '61': '종합 보고서',
            '200': '자산 일보',
            '123': '고객 재고표-고객별',
            '124': '고객 재고표-영업담당별',
            '125': '고객 재고표-상품별',
            '126': '고객 대조표-상품별',
            '127': '고객 대조표-전표별',
            '128': '계좌 수지 명세표',
            '129': '가격 정산 명세표',
            '199': '가격 정산 집계표-상품별',
            '134': '고객 이자표',
            '135': '고객 창고 이자표',
            '168': '순금 이익표',
            '169': '순금 판매 이익표-전표별',
            '208': '순금 판매 정산 이익표',
            '211': '순금 원가 명세표',
            '163': '바코드 공임 이익표',
            '177': '바코드 판매 이익표',
            '164': '금은 도금 공임 이익표',
            '170': '금은 도금 판매 이익표',
            '205': '배합 판매 이익표-고객별',
            '206': '배합 판매 이익표-상품별',
            '207': '배합 판매 이익표-전표별',
            '179': '포지션 통계표',
            '189': '가격 설정 명세표',
            '180': '가격 설정 정산 명세표',
            '182': '가격 설정 미정산 명세표',
            '183': '가격 설정 미정산 집계표-상품별',
            '201': '가격 설정 미정산 집계표-고객별',
            '9': '카테고리 목록',
            '10': '카테고리 설정',
            '114': '전표 종류',
            '149': '카운터 관리',
            '171': '부서 관리',
            '172': '계좌 관리',
            '173': '가격 설정 유형 관리',
            '175': '금 소재 가격 설정 방안',
            '191': '정산 방법 관리',
            '11': '직원 관리',
            '14': '고객 공급업체 관리',
            '121': '상품 데이터 관리',
            '98': '매장 관리',
            '22': '일일 금 가격 관리',
            '89': '이자 방안 관리',
            '13': '권한 목록',
            '67': '고객 공임',
            '130': '공임 방안 관리',
            '92': '재고 분석',
            '102': '홈',
            '216': '비용 프로젝트 관리',
            '219': '용어 번역 관리',
            '220': '회원 관리',
            '221': '회원 태그 관리',
            '222': '회원储值 관리',
            '223': '회원储值 명세표',
            '224': '회원 갱신 관리',
            '225': '충전 요금제 관리',
            '226': '바코드 조립 관리',
            '226000': '바코드 조립 이력 전표',
            '227': '바코드 분해 관리',
            '227000': '바코드 분해 이력 전표',
            '228': '정제 상세 보고서',
            '229': '정제 일일 보고서'
        },
        translationNouns: {
            searchPlaceholder: '검색 내용을 입력하세요',
            index: '번호',
            zh_CN: '중국어',
            zh_TW: '중국어 번체',
            en: '영어',
            ja: '일본어',
            ko: '한국어',
            fr: '프랑스어',
            de: '독일어',
            ru: '러시아어',
            ar: '아랍어',
            ms: '말레이어',
            vi: '베트남어',
            th: '태국어',
            hi: '힌디어',
            confirmDelete: '삭제하시겠습니까?',
            addSuccess: '추가 성공',
            deleteSuccess: '삭제 성공',
            zh_CNRequired: '중국어 명사는 필수입니다'
        }
    },
    'ar': {
        // عام
        common: {
            all: 'الكل',
            confirm: 'تأكيد',
            cancel: 'إلغاء',
            search: 'بحث',
            reset: 'إعادة تعيين',
            submit: 'إرسال',
            close: 'إغلاق',
            back: 'رجوع',
            refresh: 'تحديث',
            filter: 'تصفية',
            operation: 'عملية',
            success: 'نجاح',
            error: 'خطأ',
            warning: 'تحذير',
            info: 'معلومة',
            selectDate: 'اختر التاريخ',
            pleaseSelect: 'يرجى الاختيار',
            noData: 'لا توجد بيانات',

            save: 'حفظ',
            add: 'إنشاء جديد',
            edit: 'تعديل',
            delete: 'حذف',
            print: 'طباعة',
            audit: 'مراجعة',
            cancelAudit: 'إلغاء المراجعة',
            historyBill: 'سجل المستندات',

            export: 'تصدير',
            import: 'استيراد',
            importDetail: 'تفاصيل الاستيراد',
            electronicScale: 'ميزان إلكتروني',

            creator: 'المنشئ',
            modifier: 'المعدل',
            createTime: 'وقت الإنشاء',
            modifyTime: 'وقت التعديل',
            auditor: 'المراجع',
            auditStatus: 'حالة المراجعة',
            audited: 'تمت المراجعة',
            notAudited: 'لم تتم المراجعة',
            auditTime: 'وقت المراجعة',

            label: 'علامة',
            barcodelabel: 'علامة الباركود',
            diyLabel: 'علامة مخصصة',
            rfidLabel: 'RFID',

            productDetail: 'تفاصيل المنتج',
            accountDetail: 'تفاصيل الحساب',
            paymentDetail: 'تفاصيل الدفع',

            allPriceSettlement: 'تسوية جميع الأسعار',
            allMaterialSettlement: 'تسوية جميع المواد',
            sequentialPriceSettlement: 'تسوية الأسعار بالتتابع',
            sequentialMaterialSettlement: 'تسوية المواد بالتتابع',

            billNo: 'رقم المستند',
            billDate: 'تاريخ المستند',
            billType: 'نوع المستند',
            customer: 'العميل',
            counter: 'الطاولة',
            salesman: 'مندوب المبيعات',
            currency: 'العملة',
            handler: 'المعالج',
            store: 'المتجر',
            remark: 'ملاحظة',

            totalQty: 'إجمالي الكمية',
            totalAmt: 'إجمالي المبلغ',
            priceSettledQty: 'كمية تسوية السعر',
            materialSettledQty: 'كمية تسوية المواد',
            payableAmt: 'المبلغ المستحق',
            unroundedAmt: 'المبلغ غير المقرب',
            totalWeight: 'إجمالي الوزن',
            totalNetGoldWeight: 'إجمالي وزن الذهب الصافي',
            priceSettledWeight: 'وزن تسوية السعر',
            materialSettledWeight: 'وزن تسوية المواد',
            paidAmt: 'المبلغ المدفوع',

            columnConfig: 'إعدادات الأعمدة',
            displayedFields: 'الحقول المعروضة',
            dragToReorder: 'اسحب لإعادة ترتيب الحقول',
            optionalFields: 'الحقول الاختيارية',
            
            changePassword: 'تغيير كلمة المرور',
            oldPassword: 'كلمة المرور القديمة',
            newPassword: 'كلمة المرور الجديدة',
            confirmPassword: 'تأكيد كلمة المرور',
            modify: 'تعديل',
            logout: 'تسجيل الخروج',
            bindWechat: 'ربط WeChat',
            
            // قائمة التنقل
            home: 'الرئيسية',
            marketingManagement: 'إدارة التسويق',
            accountManagement: 'إدارة الحسابات',
            dataAndSettings: 'البيانات والإعدادات',
            systemSettings: 'إعدادات النظام',
            productionManagement: 'إدارة الإنتاج',

            closeAll: 'إغلاق الكل',
            closeOther: 'إغلاق الأخرى',
            scrollLeft: 'تمرير لليسار',
            scrollRight: 'تمرير لليمين',

            fullscreen: 'ملء الشاشة',
            exitFullscreen: 'إلغاء ملء الشاشة',
            unreadMessages: '{count} رسالة غير مقروءة',
            noUnreadMessages: 'لا توجد رسائل غير مقروءة',
            
            bindSuccess: 'تم الربط بنجاح!',
            passwordModified: 'تم تغيير كلمة المرور بنجاح',
            languageSwitched: 'تم تغيير اللغة إلى العربية'
        },
        navMenu: {
            '53': 'قائمة الإشعارات',
            '131': 'قالب الطباعة',
            '159': 'تهيئة قالب الطباعة',
            '153': 'إعدادات أعمدة الجدول',
            '132': 'أولوية بيانات تكلفة العمالة',
            '52': 'سجل العمليات',
            '51': 'معلمات النظام',
            '103': 'إدارة قواعد أرقام المستندات',
            '133': 'معلومات النظام',
            '29': 'إدارة طلبات الطاولة',
            '29000': 'سجل إدارة طلبات الطاولة',
            '30': 'إدارة التخزين',
            '30000': 'سجل إدارة التخزين',
            '31': 'إدارة الإخراج',
            '31000': 'سجل إدارة الإخراج',
            '108': 'إرجاع العميل',
            '108000': 'سجل إرجاع العميل',
            '109': 'إرجاع المصنع',
            '109000': 'سجل إرجاع المصنع',
            '176': 'إدارة الشراء والبيع',
            '176000': 'سجل إدارة الشراء والبيع',
            '195': 'تسوية إعادة الشراء بالتسعير',
            '195000': 'سجل تسوية إعادة الشراء بالتسعير',
            '198': 'تسوية المبيعات بالتسعير',
            '198000': 'سجل تسوية المبيعات بالتسعير',
            '187': 'إدارة تخزين المواد القديمة',
            '187000': 'سجل إدارة تخزين المواد القديمة',
            '184': 'إدارة إرسال التكرير',
            '184000': 'سجل إدارة إرسال التكرير',
            '186': 'إدارة جودة التكرير',
            '186000': 'سجل إدارة جودة التكرير',
            '185': 'إدارة استرداد التكرير',
            '185000': 'سجل إدارة استرداد التكرير',
            '196': 'إخراج التصنيع الخارجي',
            '196000': 'سجل إخراج التصنيع الخارجي',
            '197': 'تخزين التصنيع الخارجي',
            '197000': 'سجل تخزين التصنيع الخارجي',
            '214': 'إدارة تخزين المواد الخام',
            '214000': 'سجل إدارة تخزين المواد الخام',
            '215': 'إدارة إخراج المواد الخام',
            '215000': 'سجل إدارة إخراج المواد الخام',
            '147': 'إدارة تقسيم الوزن',
            '147000': 'سجل إدارة تقسيم الوزن',
            '154': 'تخزين الباركود',
            '154000': 'سجل تخزين الباركود',
            '165': 'إخراج مبيعات الباركود',
            '165000': 'سجل إخراج مبيعات الباركود',
            '166': 'إرجاع شراء الباركود',
            '166000': 'سجل إرجاع شراء الباركود',
            '167': 'إرجاع مبيعات الباركود',
            '167000': 'سجل إرجاع مبيعات الباركود',
            '210': 'طباعة علامة المنتج',
            '155': 'تخزين الذهب والفضة',
            '155000': 'سجل تخزين الذهب والفضة',
            '156': 'إخراج الذهب والفضة',
            '156000': 'سجل إخراج الذهب والفضة',
            '157': 'إرجاع شراء الذهب والفضة',
            '157000': 'سجل إرجاع شراء الذهب والفضة',
            '158': 'إرجاع مبيعات الذهب والفضة',
            '158000': 'سجل إرجاع مبيعات الذهب والفضة',
            '161': 'تسوية تحويل الذهب والفضة',
            '161000': 'سجل تسوية تحويل الذهب والفضة',
            '32': 'إدارة التحويل',
            '32000': 'سجل إدارة التحويل',
            '33': 'إدارة تعديل المخزون',
            '33000': 'سجل إدارة تعديل المخزون',
            '148': 'تعديل معلومات الباركود',
            '148000': 'سجل تعديل معلومات الباركود',
            '150': 'سجل الباركود',
            '151': 'جرد مخزون الباركود',
            '151000': 'سجل جرد مخزون الباركود',
            '192': 'إدارة التجارة الدولية',
            '193': 'دليل التجارة التحويلية',
            '47': 'التقرير الشامل',
            '46': 'تقرير المخزون',
            '188': 'تقرير إحصائيات تكرير المعادن',
            '209': 'تقرير إحصائيات التصنيع الخارجي',
            '45': 'جدول المخزون',
            '112': 'المخزون حسب الفئة',
            '212': 'مخزون رقم المنتج',
            '213': 'تفاصيل مخزون رقم المنتج',
            '152': 'مخزون الباركود',
            '160': 'مخزون الذهب والفضة',
            '63': 'تفاصيل الطلب',
            '58': 'تفاصيل التحويل',
            '146': 'ملخص التحويل',
            '48': 'تفاصيل التخزين',
            '115': 'ملخص التخزين حسب العميل',
            '116': 'ملخص التخزين حسب المنتج',
            '54': 'تفاصيل الإخراج',
            '118': 'ملخص الإخراج حسب العميل',
            '119': 'ملخص الإخراج حسب المندوب',
            '117': 'ملخص الإخراج حسب المنتج',
            '120': 'تفاصيل مستند الإدخال والإخراج',
            '122': 'تفاصيل حساب الإدخال والإخراج',
            '190': 'قائمة مستندات الإدخال والإخراج',
            '162': 'ملخص تكلفة العمالة حسب المندوب',
            '34': 'إدارة تسوية الأسعار',
            '34000': 'سجل إدارة تسوية الأسعار',
            '218': 'تسوية رصيد المواد',
            '218000': 'سجل تسوية رصيد المواد',
            '174': 'تسعير المعادن',
            '174000': 'سجل تسعير المعادن',
            '178': 'تسوية تسعير المعادن',
            '178000': 'سجل تسوية تسعير المعادن',
            '194': 'الميزانية العمومية',
            '35': 'إدارة التحصيل',
            '35000': 'سجل إدارة التحصيل',
            '36': 'إدارة الدفع',
            '36000': 'سجل إدارة الدفع',
            '90': 'إدارة الفوائد',
            '38': 'ترحيل الحساب',
            '37': 'تعديل الحساب',
            '37000': 'سجل تعديل الحساب',
            '41': 'تعديل المواد',
            '41000': 'سجل تعديل المواد',
            '42': 'تعديل الحساب',
            '42000': 'سجل تعديل الحساب',
            '39': 'تحويل العملة',
            '39000': 'سجل تحويل العملة',
            '40': 'تحويل المواد',
            '40000': 'سجل تحويل المواد',
            '61': 'التقرير الشامل',
            '200': 'التقرير اليومي للأصول',
            '123': 'رصيد العميل حسب العميل',
            '124': 'رصيد العميل حسب المندوب',
            '125': 'رصيد العميل حسب المنتج',
            '126': 'كشف حساب العميل حسب المنتج',
            '127': 'كشف حساب العميل حسب المستند',
            '128': 'تفاصيل الدخل والمصروفات',
            '129': 'تفاصيل تسوية الأسعار',
            '199': 'ملخص تسوية الأسعار حسب المنتج',
            '134': 'فوائد العميل',
            '135': 'فوائد تخزين العميل',
            '168': 'أرباح الذهب الخالص',
            '169': 'أرباح مبيعات الذهب الخالص حسب المستند',
            '208': 'أرباح تسوية مبيعات الذهب الخالص',
            '211': 'تفاصيل تكلفة الذهب الخالص',
            '163': 'أرباح تكلفة عمالة الباركود',
            '177': 'أرباح مبيعات الباركود',
            '164': 'أرباح تكلفة عمالة الذهب والفضة',
            '170': 'أرباح مبيعات الذهب والفضة',
            '205': 'أرباح مبيعات التوزيع حسب العميل',
            '206': 'أرباح مبيعات التوزيع حسب المنتج',
            '207': 'أرباح مبيعات التوزيع حسب المستند',
            '179': 'إحصائيات المراكز',
            '189': 'تفاصيل التسعير',
            '180': 'تفاصيل تسوية التسعير',
            '182': 'تفاصيل التسعير غير المسوى',
            '183': 'ملخص التسعير غير المسوى حسب المنتج',
            '201': 'ملخص التسعير غير المسوى حسب العميل',
            '9': 'قائمة الفئات',
            '10': 'إعدادات الفئات',
            '114': 'نوع المستند',
            '149': 'إدارة الطاولة',
            '171': 'إدارة القسم',
            '172': 'إدارة الحساب',
            '173': 'إدارة نوع التسعير',
            '175': 'خطة تسعير المعادن',
            '191': 'إدارة طريقة التسوية',
            '11': 'إدارة الموظفين',
            '14': 'إدارة العملاء والموردين',
            '121': 'إدارة بيانات المنتج',
            '98': 'إدارة المتجر',
            '22': 'السعر اليومي للذهب',
            '89': 'خطة الفوائد',
            '13': 'قائمة الصلاحيات',
            '67': 'تكلفة عمالة العميل',
            '130': 'خطة تكلفة العمالة',
            '92': 'تحليل المخزون',
            '102': 'الرئيسية',
            '216': 'إدارة مشاريع المصروفات',
            '219': 'إدارة ترجمة المصطلحات',
            '220': 'إدارة الأعضاء',
            '221': 'إدارة علامات الأعضاء',
            '222': 'إدارة القيمة المخزنة للأعضاء',
            '223': 'تقرير معاملات القيمة المخزنة للأعضاء',
            '224': 'إدارة تجديد اشتراكات الأعضاء',
            '225': 'إدارة خطط القيمة المخزنة',
            '226': 'إدارة تجميع الباركود',
            '226000': 'سجل تجميع الباركود',
            '227': 'إدارة تفكيك الباركود',
            '227000': 'سجل تفكيك الباركود',
            '228': 'تقرير تفصيلي للتكرير',
            '229': 'تقرير يومي للتكرير'
        },
        translationNouns: {
            searchPlaceholder: 'أدخل محتوى البحث',
            index: 'الرقم',
            zh_CN: 'الصينية',
            zh_TW: 'الصينية التقليدية',
            en: 'الإنجليزية',
            ja: 'اليابانية',
            ko: 'الكورية',
            fr: 'الفرنسية',
            de: 'الألمانية',
            ru: 'الروسية',
            ar: 'العربية',
            ms: 'الملايو',
            vi: 'الفيتنامية',
            th: 'التايلاندية',
            hi: 'الهندية',
            confirmDelete: 'هل أنت متأكد من الحذف؟',
            addSuccess: 'تمت الإضافة بنجاح',
            deleteSuccess: 'تم الحذف بنجاح',
            zh_CNRequired: 'الاسم الصيني مطلوب'
        }
    },
    'ms': {
        // Umum
        common: {
            all: 'Semua',
            confirm: 'Sahkan',
            cancel: 'Batal',
            search: 'Cari',
            reset: 'Set Semula',
            submit: 'Hantar',
            close: 'Tutup',
            back: 'Kembali',
            refresh: 'Muat Semula',
            filter: 'Tapis',
            operation: 'Operasi',
            success: 'Berjaya',
            error: 'Ralat',
            warning: 'Amaran',
            info: 'Maklumat',
            selectDate: 'Pilih Tarikh',
            pleaseSelect: 'Sila pilih',
            noData: 'Tiada data',

            save: 'Simpan',
            add: 'Cipta Baru',
            edit: 'Sunting',
            delete: 'Padam',
            print: 'Cetak',
            audit: 'Semak',
            cancelAudit: 'Batal Semakan',
            historyBill: 'Sejarah Dokumen',

            export: 'Eksport',
            import: 'Import',
            importDetail: 'Butiran Import',
            electronicScale: 'Penimbang Elektronik',

            creator: 'Pencipta',
            modifier: 'Pengubah',
            createTime: 'Masa Penciptaan',
            modifyTime: 'Masa Perubahan',
            auditor: 'Penyemak',
            auditStatus: 'Status Semakan',
            audited: 'Telah Disemak',
            notAudited: 'Belum Disemak',
            auditTime: 'Masa Semakan',

            label: 'Label',
            barcodelabel: 'Label Kod Bar',
            diyLabel: 'Label Tersuai',
            rfidLabel: 'RFID',

            productDetail: 'Butiran Produk',
            accountDetail: 'Butiran Akaun',
            paymentDetail: 'Butiran Bayaran',

            allPriceSettlement: 'Penyelesaian Harga Semua',
            allMaterialSettlement: 'Penyelesaian Bahan Semua',
            sequentialPriceSettlement: 'Penyelesaian Harga Berurutan',
            sequentialMaterialSettlement: 'Penyelesaian Bahan Berurutan',

            billNo: 'No. Dokumen',
            billDate: 'Tarikh Dokumen',
            billType: 'Jenis Dokumen',
            customer: 'Pelanggan',
            counter: 'Kaunter',
            salesman: 'Jurujual',
            currency: 'Mata Wang',
            handler: 'Pengendali',
            store: 'Kedai',
            remark: 'Catatan',

            totalQty: 'Jumlah Kuantiti',
            totalAmt: 'Jumlah Amaun',
            priceSettledQty: 'Kuantiti Penyelesaian Harga',
            materialSettledQty: 'Kuantiti Penyelesaian Bahan',
            payableAmt: 'Amaun Perlu Dibayar',
            unroundedAmt: 'Amaun Tidak Dibundarkan',
            totalWeight: 'Jumlah Berat',
            totalNetGoldWeight: 'Jumlah Berat Emas Bersih',
            priceSettledWeight: 'Berat Penyelesaian Harga',
            materialSettledWeight: 'Berat Penyelesaian Bahan',
            paidAmt: 'Amaun Telah Dibayar',

            columnConfig: 'Konfigurasi Lajur',
            displayedFields: 'Medan yang Dipaparkan',
            dragToReorder: 'Seret untuk menyusun semula medan',
            optionalFields: 'Medan Pilihan',
            
            changePassword: 'Tukar Kata Laluan',
            oldPassword: 'Kata Laluan Lama',
            newPassword: 'Kata Laluan Baru',
            confirmPassword: 'Sahkan Kata Laluan',
            modify: 'Sunting',
            logout: 'Log Keluar',
            bindWechat: 'Ikat WeChat',
            
            // Menu Navigasi
            home: 'Laman Utama',
            marketingManagement: 'Pengurusan Pemasaran',
            accountManagement: 'Pengurusan Akaun',
            dataAndSettings: 'Data & Tetapan',
            systemSettings: 'Tetapan Sistem',
            productionManagement: 'Pengurusan Pengeluaran',

            closeAll: 'Tutup Semua',
            closeOther: 'Tutup Lain',
            scrollLeft: 'Tatal Kiri',
            scrollRight: 'Tatal Kanan',

            fullscreen: 'Skrin Penuh',
            exitFullscreen: 'Keluar Skrin Penuh',
            unreadMessages: '{count} mesej belum dibaca',
            noUnreadMessages: 'Tiada mesej belum dibaca',
            
            bindSuccess: 'Berjaya diikat!',
            passwordModified: 'Kata laluan berjaya ditukar',
            languageSwitched: 'Bahasa telah ditukar kepada Bahasa Melayu'
        },
        navMenu: {
            '53': 'Senarai Notis',
            '131': 'Templat Cetak',
            '159': 'Inisialisasi Templat Cetak',
            '153': 'Tetapan Lajur Jadual',
            '132': 'Keutamaan Data Kos Buruh',
            '52': 'Log Operasi',
            '51': 'Parameter Sistem',
            '103': 'Pengurusan Peraturan No. Dokumen',
            '133': 'Maklumat Sistem',
            '29': 'Pengurusan Pesanan Kaunter',
            '29000': 'Sejarah Pengurusan Pesanan Kaunter',
            '30': 'Pengurusan Masuk Gudang',
            '30000': 'Sejarah Pengurusan Masuk Gudang',
            '31': 'Pengurusan Keluar Gudang',
            '31000': 'Sejarah Pengurusan Keluar Gudang',
            '108': 'Pemulangan Pelanggan',
            '108000': 'Sejarah Pemulangan Pelanggan',
            '109': 'Pemulangan Kilang',
            '109000': 'Sejarah Pemulangan Kilang',
            '176': 'Pengurusan Beli & Jual',
            '176000': 'Sejarah Pengurusan Beli & Jual',
            '195': 'Penyelesaian Pembelian Semula Harga',
            '195000': 'Sejarah Penyelesaian Pembelian Semula Harga',
            '198': 'Penyelesaian Jualan Harga',
            '198000': 'Sejarah Penyelesaian Jualan Harga',
            '187': 'Pengurusan Masuk Bahan Lama',
            '187000': 'Sejarah Pengurusan Masuk Bahan Lama',
            '184': 'Pengurusan Penghantaran Penulenan',
            '184000': 'Sejarah Pengurusan Penghantaran Penulenan',
            '186': 'Pengurusan Kualiti Penulenan',
            '186000': 'Sejarah Pengurusan Kualiti Penulenan',
            '185': 'Pengurusan Perolehan Penulenan',
            '185000': 'Sejarah Pengurusan Perolehan Penulenan',
            '196': 'Pengeluaran Pemprosesan Luar',
            '196000': 'Sejarah Pengeluaran Pemprosesan Luar',
            '197': 'Masuk Gudang Pemprosesan Luar',
            '197000': 'Sejarah Masuk Gudang Pemprosesan Luar',
            '214': 'Pengurusan Masuk Bahan Mentah',
            '214000': 'Sejarah Pengurusan Masuk Bahan Mentah',
            '215': 'Pengurusan Keluar Bahan Mentah',
            '215000': 'Sejarah Pengurusan Keluar Bahan Mentah',
            '147': 'Pengurusan Pembahagian Berat',
            '147000': 'Sejarah Pengurusan Pembahagian Berat',
            '154': 'Masuk Gudang Kod Bar',
            '154000': 'Sejarah Masuk Gudang Kod Bar',
            '165': 'Keluar Jualan Kod Bar',
            '165000': 'Sejarah Keluar Jualan Kod Bar',
            '166': 'Pemulangan Pembelian Kod Bar',
            '166000': 'Sejarah Pemulangan Pembelian Kod Bar',
            '167': 'Pemulangan Jualan Kod Bar',
            '167000': 'Sejarah Pemulangan Jualan Kod Bar',
            '210': 'Cetakan Label Produk',
            '155': 'Masuk Gudang Emas Perak',
            '155000': 'Sejarah Masuk Gudang Emas Perak',
            '156': 'Keluar Emas Perak',
            '156000': 'Sejarah Keluar Emas Perak',
            '157': 'Pemulangan Pembelian Emas Perak',
            '157000': 'Sejarah Pemulangan Pembelian Emas Perak',
            '158': 'Pemulangan Jualan Emas Perak',
            '158000': 'Sejarah Pemulangan Jualan Emas Perak',
            '161': 'Penyelesaian Pindahan Emas Perak',
            '161000': 'Sejarah Penyelesaian Pindahan Emas Perak',
            '32': 'Pengurusan Pindahan',
            '32000': 'Sejarah Pengurusan Pindahan',
            '33': 'Pengurusan Pelarasan Stok',
            '33000': 'Sejarah Pengurusan Pelarasan Stok',
            '148': 'Pelarasan Maklumat Kod Bar',
            '148000': 'Sejarah Pelarasan Maklumat Kod Bar',
            '150': 'Sejarah Kod Bar',
            '151': 'Pengiraan Stok Kod Bar',
            '151000': 'Sejarah Pengiraan Stok Kod Bar',
            '192': 'Pengurusan Perdagangan Antarabangsa',
            '193': 'Buku Perdagangan Pemprosesan',
            '47': 'Laporan Komprehensif',
            '46': 'Jadual Stok',
            '188': 'Jadual Statistik Penulenan Logam',
            '209': 'Jadual Statistik Pemprosesan Luar',
            '45': 'Jadual Stok',
            '112': 'Stok Mengikut Kategori',
            '212': 'Stok No. Produk',
            '213': 'Butiran Stok No. Produk',
            '152': 'Stok Kod Bar',
            '160': 'Stok Emas Perak',
            '63': 'Butiran Pesanan',
            '58': 'Butiran Pindahan',
            '146': 'Ringkasan Pindahan',
            '48': 'Butiran Masuk Gudang',
            '115': 'Ringkasan Masuk Gudang Mengikut Pelanggan',
            '116': 'Ringkasan Masuk Gudang Mengikut Produk',
            '54': 'Butiran Keluar Gudang',
            '118': 'Ringkasan Keluar Gudang Mengikut Pelanggan',
            '119': 'Ringkasan Keluar Gudang Mengikut Jurujual',
            '117': 'Ringkasan Keluar Gudang Mengikut Produk',
            '120': 'Butiran Dokumen Masuk & Keluar',
            '122': 'Butiran Akaun Masuk & Keluar',
            '190': 'Senarai Dokumen Masuk & Keluar',
            '162': 'Ringkasan Kos Buruh Mengikut Jurujual',
            '34': 'Pengurusan Penyelesaian Harga',
            '34000': 'Sejarah Pengurusan Penyelesaian Harga',
            '218': 'Penyelesaian Baki Bahan',
            '218000': 'Sejarah Penyelesaian Baki Bahan',
            '174': 'Penetapan Harga Logam',
            '174000': 'Sejarah Penetapan Harga Logam',
            '178': 'Penyelesaian Penetapan Harga Logam',
            '178000': 'Sejarah Penyelesaian Penetapan Harga Logam',
            '194': 'Kunci Kunci',
            '35': 'Pengurusan Pungutan',
            '35000': 'Sejarah Pengurusan Pungutan',
            '36': 'Pengurusan Bayaran',
            '36000': 'Sejarah Pengurusan Bayaran',
            '90': 'Pengurusan Faedah',
            '38': 'Posting Akaun',
            '37': 'Pelarasan Akaun',
            '37000': 'Sejarah Pelarasan Akaun',
            '41': 'Pelarasan Bahan',
            '41000': 'Sejarah Pelarasan Bahan',
            '42': 'Pelarasan Akaun',
            '42000': 'Sejarah Pelarasan Akaun',
            '39': 'Penukaran Mata Wang',
            '39000': 'Sejarah Penukaran Mata Wang',
            '40': 'Penukaran Bahan',
            '40000': 'Sejarah Penukaran Bahan',
            '61': 'Laporan Komprehensif',
            '200': 'Laporan Aset Harian',
            '123': 'Baki Pelanggan Mengikut Pelanggan',
            '124': 'Baki Pelanggan Mengikut Jurujual',
            '125': 'Baki Pelanggan Mengikut Produk',
            '126': 'Penyata Pelanggan Mengikut Produk',
            '127': 'Penyata Pelanggan Mengikut Dokumen',
            '128': 'Butiran Pendapatan & Perbelanjaan Akaun',
            '129': 'Butiran Penyelesaian Harga',
            '199': 'Ringkasan Penyelesaian Harga Mengikut Produk',
            '134': 'Jadual Faedah Pelanggan',
            '135': 'Jadual Faedah Storan Pelanggan',
            '168': 'Jadual Keuntungan Emas Tulen',
            '169': 'Jadual Keuntungan Jualan Emas Tulen Mengikut Dokumen',
            '208': 'Jadual Keuntungan Penyelesaian Jualan Emas Tulen',
            '211': 'Jadual Kos Emas Tulen',
            '163': 'Jadual Keuntungan Kos Buruh Kod Bar',
            '177': 'Jadual Keuntungan Jualan Kod Bar',
            '164': 'Jadual Keuntungan Kos Buruh Emas Perak',
            '170': 'Jadual Keuntungan Jualan Emas Perak',
            '205': 'Jadual Keuntungan Jualan Agihan Mengikut Pelanggan',
            '206': 'Jadual Keuntungan Jualan Agihan Mengikut Produk',
            '207': 'Jadual Keuntungan Jualan Agihan Mengikut Dokumen',
            '179': 'Jadual Statistik Kedudukan',
            '189': 'Butiran Penetapan Harga',
            '180': 'Butiran Penyelesaian Penetapan Harga',
            '182': 'Butiran Penetapan Harga Belum Selesai',
            '183': 'Ringkasan Penetapan Harga Belum Selesai Mengikut Produk',
            '201': 'Ringkasan Penetapan Harga Belum Selesai Mengikut Pelanggan',
            '9': 'Senarai Kategori',
            '10': 'Tetapan Kategori',
            '114': 'Jenis Dokumen',
            '149': 'Pengurusan Kaunter',
            '171': 'Pengurusan Jabatan',
            '172': 'Pengurusan Akaun',
            '173': 'Pengurusan Jenis Penetapan Harga',
            '175': 'Pelan Penetapan Harga Logam',
            '191': 'Pengurusan Kaedah Penyelesaian',
            '11': 'Pengurusan Kakitangan',
            '14': 'Pengurusan Pelanggan & Pembekal',
            '121': 'Pengurusan Data Produk',
            '98': 'Pengurusan Kedai',
            '22': 'Harga Emas Harian',
            '89': 'Skim Faedah',
            '13': 'Senarai Kebenaran',
            '67': 'Kos Buruh Pelanggan',
            '130': 'Skim Kos Buruh',
            '92': 'Analisis Stok',
            '102': 'Laman Utama',
            '216': 'Pengurusan Projek Perbelanjaan',
            '219': 'Pengurusan Terjemahan Istilah',
            '220': 'Pengurusan Ahli',
            '221': 'Pengurusan Tag Ahli',
            '222': 'Pengurusan Nilai Simpanan Ahli',
            '223': 'Laporan Transaksi Nilai Simpanan Ahli',
            '224': 'Pengurusan Pembaharuan Ahli',
            '225': 'Pengurusan Pelan Nilai Tersimpan',
            '226': 'Pengurusan Pemasangan Kod Bar',
            '226000': 'Sejarah Pemasangan Kod Bar',
            '227': 'Pengurusan Pembongkaran Kod Bar',
            '227000': 'Sejarah Pembongkaran Kod Bar',
            '228': 'Laporan Butiran Penulenan',
            '229': 'Laporan Harian Penulenan'
        },
        translationNouns: {
            searchPlaceholder: 'Masukkan kandungan carian',
            index: 'Bil.',
            zh_CN: 'Cina',
            zh_TW: 'Cina Tradisional',
            en: 'Inggeris',
            ja: 'Jepun',
            ko: 'Korea',
            fr: 'Perancis',
            de: 'Jerman',
            ru: 'Rusia',
            ar: 'Arab',
            ms: 'Melayu',
            vi: 'Vietnam',
            th: 'Thai',
            hi: 'Hindi',
            confirmDelete: 'Adakah anda pasti untuk memadam?',
            addSuccess: 'Berjaya ditambah',
            deleteSuccess: 'Berjaya dipadam',
            zh_CNRequired: 'Nama Cina diperlukan'
        }
    },
    'fr': {
        // Général
        common: {
            all: 'Tout',
            confirm: 'Confirmer',
            cancel: 'Annuler',
            search: 'Rechercher',
            reset: 'Réinitialiser',
            submit: 'Soumettre',
            close: 'Fermer',
            back: 'Retour',
            refresh: 'Actualiser',
            filter: 'Filtrer',
            operation: 'Opération',
            success: 'Succès',
            error: 'Erreur',
            warning: 'Avertissement',
            info: 'Info',
            selectDate: 'Sélectionner la date',
            pleaseSelect: 'Veuillez sélectionner',
            noData: 'Aucune donnée',

            save: 'Enregistrer',
            add: 'Créer',
            edit: 'Modifier',
            delete: 'Supprimer',
            print: 'Imprimer',
            audit: 'Vérifier',
            cancelAudit: 'Annuler la vérification',
            historyBill: 'Historique des documents',

            export: 'Exporter',
            import: 'Importer',
            importDetail: "Détails de l'importation",
            electronicScale: 'Balance électronique',

            creator: 'Créateur',
            modifier: 'Modificateur',
            createTime: 'Date de création',
            modifyTime: 'Date de modification',
            auditor: 'Vérificateur',
            auditStatus: 'Statut de vérification',
            audited: 'Vérifié',
            notAudited: 'Non vérifié',
            auditTime: 'Date de vérification',

            label: 'Étiquette',
            barcodelabel: 'Étiquette code-barres',
            diyLabel: 'Étiquette personnalisée',
            rfidLabel: 'RFID',

            productDetail: 'Détails du produit',
            accountDetail: 'Détails du compte',
            paymentDetail: 'Détails de paiement',

            allPriceSettlement: 'Règlement de tous les prix',
            allMaterialSettlement: 'Règlement de tous les matériaux',
            sequentialPriceSettlement: 'Règlement séquentiel des prix',
            sequentialMaterialSettlement: 'Règlement séquentiel des matériaux',

            billNo: 'N° de document',
            billDate: 'Date du document',
            billType: 'Type de document',
            customer: 'Client',
            counter: 'Comptoir',
            salesman: 'Commercial',
            currency: 'Devise',
            handler: 'Responsable',
            store: 'Magasin',
            remark: 'Remarque',

            totalQty: 'Quantité totale',
            totalAmt: 'Montant total',
            priceSettledQty: 'Qté règlement prix',
            materialSettledQty: 'Qté règlement matériaux',
            payableAmt: 'Montant payable',
            unroundedAmt: 'Montant non arrondi',
            totalWeight: 'Poids total',
            totalNetGoldWeight: 'Poids net total or',
            priceSettledWeight: 'Poids règlement prix',
            materialSettledWeight: 'Poids règlement matériaux',
            paidAmt: 'Montant payé',

            columnConfig: 'Configuration des colonnes',
            displayedFields: 'Champs affichés',
            dragToReorder: 'Glisser pour réorganiser les champs',
            optionalFields: 'Champs optionnels',
            
            changePassword: 'Changer le mot de passe',
            oldPassword: 'Ancien mot de passe',
            newPassword: 'Nouveau mot de passe',
            confirmPassword: 'Confirmer le mot de passe',
            modify: 'Modifier',
            logout: 'Déconnexion',
            bindWechat: 'Lier WeChat',
            
            // Menu de navigation
            home: 'Accueil',
            marketingManagement: 'Gestion marketing',
            accountManagement: 'Gestion des comptes',
            dataAndSettings: 'Données et paramètres',
            systemSettings: 'Paramètres système',
            productionManagement: 'Gestion de production',

            closeAll: 'Tout fermer',
            closeOther: 'Fermer les autres',
            scrollLeft: 'Défiler à gauche',
            scrollRight: 'Défiler à droite',

            fullscreen: 'Plein écran',
            exitFullscreen: 'Quitter le plein écran',
            unreadMessages: '{count} message(s) non lu(s)',
            noUnreadMessages: 'Aucun message non lu',
            
            bindSuccess: 'Liaison réussie !',
            passwordModified: 'Mot de passe modifié avec succès',
            languageSwitched: 'Langue changée en français'
        },
        navMenu: {
            '53': 'Liste des avis',
            '131': "Modèle d'impression",
            '159': "Initialisation du modèle d'impression",
            '153': 'Paramètres des colonnes',
            '132': 'Priorité des données de main-d\'œuvre',
            '52': "Journal d'opérations",
            '51': 'Paramètres système',
            '103': 'Gestion des règles de numérotation',
            '133': 'Informations système',
            '29': 'Gestion des commandes au comptoir',
            '29000': 'Historique des commandes au comptoir',
            '30': 'Gestion des entrées',
            '30000': 'Historique des entrées',
            '31': 'Gestion des sorties',
            '31000': 'Historique des sorties',
            '108': 'Retour client',
            '108000': 'Historique des retours clients',
            '109': 'Retour usine',
            '109000': 'Historique des retours usine',
            '176': "Gestion des achats et ventes",
            '176000': "Historique des achats et ventes",
            '195': 'Règlement de rachat à prix fixé',
            '195000': 'Historique du règlement de rachat',
            '198': 'Règlement de vente à prix fixé',
            '198000': 'Historique du règlement de vente',
            '187': 'Gestion des entrées de vieux matériaux',
            '187000': 'Historique des entrées de vieux matériaux',
            '184': "Gestion des envois de raffinage",
            '184000': "Historique des envois de raffinage",
            '186': 'Gestion de la qualité de raffinage',
            '186000': 'Historique de la qualité de raffinage',
            '185': 'Gestion de la récupération de raffinage',
            '185000': 'Historique de la récupération de raffinage',
            '196': 'Sortie de sous-traitance',
            '196000': 'Historique des sorties de sous-traitance',
            '197': 'Entrée de sous-traitance',
            '197000': 'Historique des entrées de sous-traitance',
            '214': 'Gestion des entrées de matières brutes',
            '214000': 'Historique des entrées de matières brutes',
            '215': 'Gestion des sorties de matières brutes',
            '215000': 'Historique des sorties de matières brutes',
            '147': 'Gestion de la répartition de poids',
            '147000': 'Historique de la répartition de poids',
            '154': 'Entrée code-barres',
            '154000': 'Historique des entrées code-barres',
            '165': 'Sortie vente code-barres',
            '165000': 'Historique des sorties vente code-barres',
            '166': 'Retour achat code-barres',
            '166000': 'Historique des retours achat code-barres',
            '167': 'Retour vente code-barres',
            '167000': 'Historique des retours vente code-barres',
            '210': "Impression d'étiquettes produits",
            '155': 'Entrée or et argent',
            '155000': "Historique des entrées or et argent",
            '156': 'Sortie or et argent',
            '156000': "Historique des sorties or et argent",
            '157': "Retour achat or et argent",
            '157000': "Historique des retours achat or et argent",
            '158': "Retour vente or et argent",
            '158000': "Historique des retours vente or et argent",
            '161': 'Règlement de transfert or et argent',
            '161000': 'Historique du règlement de transfert',
            '32': 'Gestion des transferts',
            '32000': 'Historique des transferts',
            '33': "Gestion des ajustements de stock",
            '33000': "Historique des ajustements de stock",
            '148': 'Ajustement des informations code-barres',
            '148000': "Historique des ajustements code-barres",
            '150': 'Historique des code-barres',
            '151': 'Inventaire du stock code-barres',
            '151000': "Historique de l'inventaire code-barres",
            '192': 'Gestion du commerce international',
            '193': 'Manuel du commerce de transformation',
            '47': 'Rapport global',
            '46': 'Tableau des stocks',
            '188': 'Statistiques de raffinage des métaux',
            '209': 'Statistiques de sous-traitance',
            '45': 'Tableau de stock',
            '112': 'Stock par catégorie',
            '212': 'Stock par numéro de produit',
            '213': 'Détails du stock par numéro',
            '152': 'Stock code-barres',
            '160': 'Stock or et argent',
            '63': 'Détails des commandes',
            '58': 'Détails des transferts',
            '146': 'Résumé des transferts',
            '48': "Détails des entrées",
            '115': 'Résumé des entrées par client',
            '116': 'Résumé des entrées par produit',
            '54': "Détails des sorties",
            '118': 'Résumé des sorties par client',
            '119': 'Résumé des sorties par commercial',
            '117': 'Résumé des sorties par produit',
            '120': 'Détails des documents entrées/sorties',
            '122': 'Détails des comptes entrées/sorties',
            '190': 'Liste des documents entrées/sorties',
            '162': 'Résumé des frais de main-d\'œuvre par commercial',
            '34': 'Gestion des règlements de prix',
            '34000': 'Historique des règlements de prix',
            '218': 'Règlement du solde matériaux',
            '218000': 'Historique du règlement du solde',
            '174': 'Tarification des métaux',
            '174000': 'Historique de la tarification',
            '178': 'Règlement de la tarification',
            '178000': 'Historique du règlement de tarification',
            '194': 'Bilan',
            '35': 'Gestion des encaissements',
            '35000': 'Historique des encaissements',
            '36': 'Gestion des paiements',
            '36000': 'Historique des paiements',
            '90': 'Gestion des intérêts',
            '38': 'Écriture comptable',
            '37': 'Ajustement de compte',
            '37000': "Historique des ajustements de compte",
            '41': 'Ajustement de matériau',
            '41000': "Historique des ajustements de matériau",
            '42': 'Ajustement de compte',
            '42000': "Historique des ajustements de compte",
            '39': 'Conversion de devise',
            '39000': 'Historique des conversions de devise',
            '40': 'Conversion de matériau',
            '40000': 'Historique des conversions de matériau',
            '61': 'Rapport global',
            '200': 'Rapport quotidien des actifs',
            '123': 'Solde client par client',
            '124': 'Solde client par commercial',
            '125': 'Solde client par produit',
            '126': 'Relevé client par produit',
            '127': 'Relevé client par document',
            '128': 'Détails des recettes et dépenses',
            '129': 'Détails du règlement de prix',
            '199': 'Résumé du règlement de prix par produit',
            '134': 'Table des intérêts clients',
            '135': 'Table des intérêts de stockage clients',
            '168': 'Table des bénéfices or pur',
            '169': 'Bénéfices de vente or pur par document',
            '208': 'Bénéfices de règlement de vente or pur',
            '211': "Détails des coûts de l'or pur",
            '163': 'Table des frais de main-d\'œuvre code-barres',
            '177': 'Table des bénéfices de vente code-barres',
            '164': 'Table des frais or et argent',
            '170': 'Table des bénéfices de vente or et argent',
            '205': 'Bénéfices de vente par distribution par client',
            '206': 'Bénéfices de vente par distribution par produit',
            '207': 'Bénéfices de vente par distribution par document',
            '179': 'Statistiques des positions',
            '189': 'Détails de la tarification',
            '180': 'Détails du règlement de tarification',
            '182': 'Détails de tarification non réglée',
            '183': 'Résumé de tarification non réglée par produit',
            '201': 'Résumé de tarification non réglée par client',
            '9': 'Liste des catégories',
            '10': 'Paramètres des catégories',
            '114': 'Type de document',
            '149': 'Gestion du comptoir',
            '171': 'Gestion des départements',
            '172': 'Gestion des comptes',
            '173': 'Gestion des types de tarification',
            '175': 'Plan de tarification des métaux',
            '191': 'Gestion des modes de règlement',
            '11': 'Gestion du personnel',
            '14': 'Gestion clients/fournisseurs',
            '121': 'Gestion des données produits',
            '98': 'Gestion des magasins',
            '22': 'Prix quotidien de l\'or',
            '89': 'Plan d\'intérêts',
            '13': 'Liste des permissions',
            '67': 'Frais de main-d\'œuvre client',
            '130': 'Plan de frais de main-d\'œuvre',
            '92': 'Analyse des stocks',
            '102': 'Accueil',
            '216': 'Gestion des projets de dépenses',
            '219': 'Gestion de la traduction des termes',
            '220': 'Gestion des membres',
            '221': 'Gestion des tags membres',
            '222': 'Gestion de la valeur stockée des membres',
            '223': 'Rapport des transactions de valeur stockée des membres',
            '224': 'Gestion du renouvellement des membres',
            '225': 'Gestion des plans de valeur stockée',
            '226': 'Assemblage code-barres',
            '226000': 'Historique des assemblages code-barres',
            '227': 'Démontage code-barres',
            '227000': 'Historique des démontages code-barres',
            '228': 'Rapport détaillé de purification',
            '229': 'Rapport quotidien de purification'
        },
        translationNouns: {
            searchPlaceholder: 'Entrez le contenu de recherche',
            index: 'No.',
            zh_CN: 'Chinois',
            zh_TW: 'Chinois traditionnel',
            en: 'Anglais',
            ja: 'Japonais',
            ko: 'Coréen',
            fr: 'Français',
            de: 'Allemand',
            ru: 'Russe',
            ar: 'Arabe',
            ms: 'Malais',
            vi: 'Vietnamien',
            th: 'Thaï',
            hi: 'Hindi',
            confirmDelete: 'Êtes-vous sûr de supprimer ?',
            addSuccess: 'Ajouté avec succès',
            deleteSuccess: 'Supprimé avec succès',
            zh_CNRequired: 'Le nom chinois est requis'
        }
    },
    'de': {
        // Allgemein
        common: {
            all: 'Alle',
            confirm: 'Bestätigen',
            cancel: 'Abbrechen',
            search: 'Suchen',
            reset: 'Zurücksetzen',
            submit: 'Absenden',
            close: 'Schließen',
            back: 'Zurück',
            refresh: 'Aktualisieren',
            filter: 'Filter',
            operation: 'Vorgang',
            success: 'Erfolg',
            error: 'Fehler',
            warning: 'Warnung',
            info: 'Info',
            selectDate: 'Datum auswählen',
            pleaseSelect: 'Bitte auswählen',
            noData: 'Keine Daten',

            save: 'Speichern',
            add: 'Neu erstellen',
            edit: 'Bearbeiten',
            delete: 'Löschen',
            print: 'Drucken',
            audit: 'Prüfen',
            cancelAudit: 'Prüfung abbrechen',
            historyBill: 'Dokumentenverlauf',

            export: 'Exportieren',
            import: 'Importieren',
            importDetail: 'Importdetails',
            electronicScale: 'Elektronische Waage',

            creator: 'Ersteller',
            modifier: 'Bearbeiter',
            createTime: 'Erstellungszeit',
            modifyTime: 'Bearbeitungszeit',
            auditor: 'Prüfer',
            auditStatus: 'Prüfstatus',
            audited: 'Geprüft',
            notAudited: 'Ungeprüft',
            auditTime: 'Prüfzeit',

            label: 'Etikett',
            barcodelabel: 'Barcode-Etikett',
            diyLabel: 'Benutzerdefiniertes Etikett',
            rfidLabel: 'RFID',

            productDetail: 'Produktdetails',
            accountDetail: 'Kontodetails',
            paymentDetail: 'Zahlungsdetails',

            allPriceSettlement: 'Alle Preisabrechnungen',
            allMaterialSettlement: 'Alle Materialabrechnungen',
            sequentialPriceSettlement: 'Sequentielle Preisabrechnungen',
            sequentialMaterialSettlement: 'Sequentielle Materialabrechnungen',

            billNo: 'Dokumentennr.',
            billDate: 'Belegdatum',
            billType: 'Belegart',
            customer: 'Kunde',
            counter: 'Theke',
            salesman: 'Verkäufer',
            currency: 'Währung',
            handler: 'Bearbeiter',
            store: 'Filiale',
            remark: 'Bemerkung',

            totalQty: 'Gesamtmenge',
            totalAmt: 'Gesamtbetrag',
            priceSettledQty: 'Preisabrechnungsmenge',
            materialSettledQty: 'Materialabrechnungsmenge',
            payableAmt: 'Zahlbarer Betrag',
            unroundedAmt: 'Ungerundeter Betrag',
            totalWeight: 'Gesamtgewicht',
            totalNetGoldWeight: 'Gesamtes Nettogoldgewicht',
            priceSettledWeight: 'Preisabrechnungsgewicht',
            materialSettledWeight: 'Materialabrechnungsgewicht',
            paidAmt: 'Bezahlter Betrag',

            columnConfig: 'Spaltenkonfiguration',
            displayedFields: 'Angezeigte Felder',
            dragToReorder: 'Ziehen zum Neuordnen der Felder',
            optionalFields: 'Optionale Felder',
            
            changePassword: 'Passwort ändern',
            oldPassword: 'Altes Passwort',
            newPassword: 'Neues Passwort',
            confirmPassword: 'Passwort bestätigen',
            modify: 'Bearbeiten',
            logout: 'Abmelden',
            bindWechat: 'WeChat verknüpfen',
            
            // Navigationsmenü
            home: 'Startseite',
            marketingManagement: 'Marketingverwaltung',
            accountManagement: 'Kontoverwaltung',
            dataAndSettings: 'Daten & Einstellungen',
            systemSettings: 'Systemeinstellungen',
            productionManagement: 'Produktionsverwaltung',

            closeAll: 'Alle schließen',
            closeOther: 'Andere schließen',
            scrollLeft: 'Nach links scrollen',
            scrollRight: 'Nach rechts scrollen',

            fullscreen: 'Vollbild',
            exitFullscreen: 'Vollbild beenden',
            unreadMessages: '{count} ungelesene Nachricht(en)',
            noUnreadMessages: 'Keine ungelesenen Nachrichten',
            
            bindSuccess: 'Verknüpfung erfolgreich!',
            passwordModified: 'Passwort erfolgreich geändert',
            languageSwitched: 'Sprache auf Deutsch geändert'
        },
        navMenu: {
            '53': 'Benachrichtigungsliste',
            '131': 'Druckvorlage',
            '159': 'Druckvorlageninitialisierung',
            '153': 'Tabellenspalten-Einstellungen',
            '132': 'Arbeitskosten-Datenpriorität',
            '52': 'Betriebsprotokoll',
            '51': 'Systemparameter',
            '103': 'Belegnummernregeln-Verwaltung',
            '133': 'Systeminformationen',
            '29': 'Thekenbestellungsverwaltung',
            '29000': 'Thekenbestellungsverlauf',
            '30': 'Eingangsverwaltung',
            '30000': 'Eingangsverlauf',
            '31': 'Ausgangsverwaltung',
            '31000': 'Ausgangsverlauf',
            '108': 'Kundenrückgabe',
            '108000': 'Kundenrückgabeverlauf',
            '109': 'Fabrikrückgabe',
            '109000': 'Fabrikrückgabeverlauf',
            '176': 'Kauf- & Verkaufsverwaltung',
            '176000': 'Kauf- & Verkaufsverlauf',
            '195': 'Preis-Rückkaufabrechnung',
            '195000': 'Preis-Rückkaufabrechnungsverlauf',
            '198': 'Preis-Verkaufsabrechnung',
            '198000': 'Preis-Verkaufsabrechnungsverlauf',
            '187': 'Altmaterial-Eingangsverwaltung',
            '187000': 'Altmaterial-Eingangsverlauf',
            '184': 'Raffinationsversandverwaltung',
            '184000': 'Raffinationsversandverlauf',
            '186': 'Raffinationsqualitätsverwaltung',
            '186000': 'Raffinationsqualitätsverlauf',
            '185': 'Raffinationsrückgewinnungsverwaltung',
            '185000': 'Raffinationsrückgewinnungsverlauf',
            '196': 'Fremdverarbeitungsausgang',
            '196000': 'Fremdverarbeitungsausgangsverlauf',
            '197': 'Fremdverarbeitungseingang',
            '197000': 'Fremdverarbeitungseingangsverlauf',
            '214': 'Rohmaterial-Eingangsverwaltung',
            '214000': 'Rohmaterial-Eingangsverlauf',
            '215': 'Rohmaterial-Ausgangsverwaltung',
            '215000': 'Rohmaterial-Ausgangsverlauf',
            '147': 'Gewichtsteilungsverwaltung',
            '147000': 'Gewichtsteilungsverlauf',
            '154': 'Barcode-Eingang',
            '154000': 'Barcode-Eingangsverlauf',
            '165': 'Barcode-Verkaufsausgang',
            '165000': 'Barcode-Verkaufsausgangsverlauf',
            '166': 'Barcode-Kaufsrückgabe',
            '166000': 'Barcode-Kaufsrückgabeverlauf',
            '167': 'Barcode-Verkaufsrückgabe',
            '167000': 'Barcode-Verkaufsrückgabeverlauf',
            '210': 'Produktetikettendruck',
            '155': 'Gold-Silber-Eingang',
            '155000': 'Gold-Silber-Eingangsverlauf',
            '156': 'Gold-Silber-Ausgang',
            '156000': 'Gold-Silber-Ausgangsverlauf',
            '157': 'Gold-Silber-Kaufsrückgabe',
            '157000': 'Gold-Silber-Kaufsrückgabeverlauf',
            '158': 'Gold-Silber-Verkaufsrückgabe',
            '158000': 'Gold-Silber-Verkaufsrückgabeverlauf',
            '161': 'Gold-Silber-Transferabrechnung',
            '161000': 'Gold-Silber-Transferabrechnungsverlauf',
            '32': 'Transferverwaltung',
            '32000': 'Transferverlauf',
            '33': 'Bestandsanpassungsverwaltung',
            '33000': 'Bestandsanpassungsverlauf',
            '148': 'Barcode-Informationen anpassen',
            '148000': 'Barcode-Anpassungsverlauf',
            '150': 'Barcode-Verlauf',
            '151': 'Barcode-Bestandsaufnahme',
            '151000': 'Barcode-Bestandsaufnahmeverlauf',
            '192': 'Internationaler Handel',
            '193': 'Veredelungsverkehrshandbuch',
            '47': 'Gesamtbericht',
            '46': 'Bestandsübersicht',
            '188': 'Metallraffinationsstatistik',
            '209': 'Fremdverarbeitungsstatistik',
            '45': 'Bestandstabelle',
            '112': 'Bestand nach Kategorie',
            '212': 'Artikelnr.-Bestand',
            '213': 'Artikelnr.-Bestandsdetails',
            '152': 'Barcode-Bestand',
            '160': 'Gold-Silber-Bestand',
            '63': 'Bestelldetails',
            '58': 'Transferdetails',
            '146': 'Transferzusammenfassung',
            '48': 'Eingangsdetails',
            '115': 'Eingangszusammenfassung nach Kunde',
            '116': 'Eingangszusammenfassung nach Produkt',
            '54': 'Ausgangsdetails',
            '118': 'Ausgangszusammenfassung nach Kunde',
            '119': 'Ausgangszusammenfassung nach Verkäufer',
            '117': 'Ausgangszusammenfassung nach Produkt',
            '120': 'Ein-/Ausgangsbelegdetails',
            '122': 'Ein-/Ausgangskontodetails',
            '190': 'Ein-/Ausgangsbelegliste',
            '162': 'Arbeitskostenzusammenfassung nach Verkäufer',
            '34': 'Preisabrechnungsverwaltung',
            '34000': 'Preisabrechnungsverlauf',
            '218': 'Materialsaldoabrechnung',
            '218000': 'Materialsaldoabrechnungsverlauf',
            '174': 'Metallpreisfestsetzung',
            '174000': 'Metallpreisfestsetzungsverlauf',
            '178': 'Metallpreisabrechnung',
            '178000': 'Metallpreisabrechnungsverlauf',
            '194': 'Bilanz',
            '35': 'Einzugsverwaltung',
            '35000': 'Einzugsverlauf',
            '36': 'Zahlungsverwaltung',
            '36000': 'Zahlungsverlauf',
            '90': 'Zinsverwaltung',
            '38': 'Kontobuchung',
            '37': 'Kontoanpassung',
            '37000': 'Kontoanpassungsverlauf',
            '41': 'Materialanpassung',
            '41000': 'Materialanpassungsverlauf',
            '42': 'Kontoanpassung',
            '42000': 'Kontoanpassungsverlauf',
            '39': 'Währungsumrechnung',
            '39000': 'Währungsumrechnungsverlauf',
            '40': 'Materialumrechnung',
            '40000': 'Materialumrechnungsverlauf',
            '61': 'Gesamtbericht',
            '200': 'Täglicher Vermögensbericht',
            '123': 'Kundensaldo nach Kunde',
            '124': 'Kundensaldo nach Verkäufer',
            '125': 'Kundensaldo nach Produkt',
            '126': 'Kundenabrechnung nach Produkt',
            '127': 'Kundenabrechnung nach Beleg',
            '128': 'Kontoeinnahmen/-ausgaben',
            '129': 'Preisabrechnungsdetails',
            '199': 'Preisabrechnungszusammenfassung nach Produkt',
            '134': 'Kundenzinstabelle',
            '135': 'Kundenlagerzinstabelle',
            '168': 'Feingold-Gewinntabelle',
            '169': 'Feingold-Verkaufsgewinn nach Beleg',
            '208': 'Feingold-Verkaufsabrechnungsgewinn',
            '211': 'Feingold-Kostendetails',
            '163': 'Barcode-Arbeitskostengewinn',
            '177': 'Barcode-Verkaufsgewinn',
            '164': 'Gold-Silber-Arbeitskostengewinn',
            '170': 'Gold-Silber-Verkaufsgewinn',
            '205': 'Vertriebsgewinn nach Kunde',
            '206': 'Vertriebsgewinn nach Produkt',
            '207': 'Vertriebsgewinn nach Beleg',
            '179': 'Positionsstatistik',
            '189': 'Preisfestsetzungsdetails',
            '180': 'Preisfestsetzungsabrechnungsdetails',
            '182': 'Unabgerechnete Preisfestsetzungsdetails',
            '183': 'Unabgerechnete Preisfestsetzung nach Produkt',
            '201': 'Unabgerechnete Preisfestsetzung nach Kunde',
            '9': 'Kategorieliste',
            '10': 'Kategorieeinstellungen',
            '114': 'Belegart',
            '149': 'Thekenverwaltung',
            '171': 'Abteilungsverwaltung',
            '172': 'Kontoverwaltung',
            '173': 'Preisfestsetzungstyp-Verwaltung',
            '175': 'Metallpreisfestsetzungsplan',
            '191': 'Abrechnungsartenverwaltung',
            '11': 'Personalverwaltung',
            '14': 'Kunden-/Lieferantenverwaltung',
            '121': 'Produktdatenverwaltung',
            '98': 'Filialverwaltung',
            '22': 'Täglicher Goldpreis',
            '89': 'Zinsplan',
            '13': 'Berechtigungsliste',
            '67': 'Kundenarbeitskosten',
            '130': 'Arbeitskostenplan',
            '92': 'Bestandsanalyse',
            '102': 'Startseite',
            '216': 'Kostenprojektverwaltung',
            '219': 'Begriffsübersetzungsverwaltung',
            '220': 'Mitgliederverwaltung',
            '221': 'Mitglieder-Tag-Verwaltung',
            '222': 'Mitglieder-Wertguthaben-Verwaltung',
            '223': 'Mitglieder-Wertguthaben-Transaktionsbericht',
            '224': 'Mitglieder-Erneuerungsverwaltung',
            '225': 'Guthabenplan-Verwaltung',
            '226': 'Barcode-Montage',
            '226000': 'Barcode-Montageverlauf',
            '227': 'Barcode-Demontage',
            '227000': 'Barcode-Demontageverlauf',
            '228': 'Raffinationsdetailbericht',
            '229': 'Raffinations-Tagesbericht'
        },
        translationNouns: {
            searchPlaceholder: 'Suchinhalt eingeben',
            index: 'Nr.',
            zh_CN: 'Chinesisch',
            zh_TW: 'Chinesisch Traditionell',
            en: 'Englisch',
            ja: 'Japanisch',
            ko: 'Koreanisch',
            fr: 'Französisch',
            de: 'Deutsch',
            ru: 'Russisch',
            ar: 'Arabisch',
            ms: 'Malaiisch',
            vi: 'Vietnamesisch',
            th: 'Thailändisch',
            hi: 'Hindi',
            confirmDelete: 'Möchten Sie wirklich löschen?',
            addSuccess: 'Erfolgreich hinzugefügt',
            deleteSuccess: 'Erfolgreich gelöscht',
            zh_CNRequired: 'Chinesischer Name ist erforderlich'
        }
    },
    'ru': {
        // Общие
        common: {
            all: 'Все',
            confirm: 'Подтвердить',
            cancel: 'Отмена',
            search: 'Поиск',
            reset: 'Сброс',
            submit: 'Отправить',
            close: 'Закрыть',
            back: 'Назад',
            refresh: 'Обновить',
            filter: 'Фильтр',
            operation: 'Операция',
            success: 'Успешно',
            error: 'Ошибка',
            warning: 'Предупреждение',
            info: 'Информация',
            selectDate: 'Выбрать дату',
            pleaseSelect: 'Пожалуйста, выберите',
            noData: 'Нет данных',

            save: 'Сохранить',
            add: 'Создать',
            edit: 'Редактировать',
            delete: 'Удалить',
            print: 'Печать',
            audit: 'Проверка',
            cancelAudit: 'Отменить проверку',
            historyBill: 'История документов',

            export: 'Экспорт',
            import: 'Импорт',
            importDetail: 'Детали импорта',
            electronicScale: 'Электронные весы',

            creator: 'Создатель',
            modifier: 'Редактор',
            createTime: 'Дата создания',
            modifyTime: 'Дата изменения',
            auditor: 'Проверяющий',
            auditStatus: 'Статус проверки',
            audited: 'Проверено',
            notAudited: 'Не проверено',
            auditTime: 'Дата проверки',

            label: 'Этикетка',
            barcodelabel: 'Штрих-код этикетка',
            diyLabel: 'Пользовательская этикетка',
            rfidLabel: 'RFID',

            productDetail: 'Детали продукта',
            accountDetail: 'Детали счёта',
            paymentDetail: 'Детали платежа',

            allPriceSettlement: 'Расчёт всех цен',
            allMaterialSettlement: 'Расчёт всех материалов',
            sequentialPriceSettlement: 'Последовательный расчёт цен',
            sequentialMaterialSettlement: 'Последовательный расчёт материалов',

            billNo: '№ документа',
            billDate: 'Дата документа',
            billType: 'Тип документа',
            customer: 'Клиент',
            counter: 'Прилавок',
            salesman: 'Продавец',
            currency: 'Валюта',
            handler: 'Ответственный',
            store: 'Магазин',
            remark: 'Примечание',

            totalQty: 'Общее количество',
            totalAmt: 'Общая сумма',
            priceSettledQty: 'Кол-во расчёта цен',
            materialSettledQty: 'Кол-во расчёта материалов',
            payableAmt: 'К оплате',
            unroundedAmt: 'Неокруглённая сумма',
            totalWeight: 'Общий вес',
            totalNetGoldWeight: 'Общий вес чистого золота',
            priceSettledWeight: 'Вес расчёта цен',
            materialSettledWeight: 'Вес расчёта материалов',
            paidAmt: 'Оплаченная сумма',

            columnConfig: 'Настройка столбцов',
            displayedFields: 'Отображаемые поля',
            dragToReorder: 'Перетащите для изменения порядка полей',
            optionalFields: 'Дополнительные поля',
            
            changePassword: 'Изменить пароль',
            oldPassword: 'Старый пароль',
            newPassword: 'Новый пароль',
            confirmPassword: 'Подтвердить пароль',
            modify: 'Изменить',
            logout: 'Выйти',
            bindWechat: 'Привязать WeChat',
            
            // Навигационное меню
            home: 'Главная',
            marketingManagement: 'Управление маркетингом',
            accountManagement: 'Управление счетами',
            dataAndSettings: 'Данные и настройки',
            systemSettings: 'Системные настройки',
            productionManagement: 'Управление производством',

            closeAll: 'Закрыть все',
            closeOther: 'Закрыть другие',
            scrollLeft: 'Прокрутить влево',
            scrollRight: 'Прокрутить вправо',

            fullscreen: 'Полный экран',
            exitFullscreen: 'Выйти из полного экрана',
            unreadMessages: '{count} непрочитанное(ых) сообщение(ий)',
            noUnreadMessages: 'Нет непрочитанных сообщений',
            
            bindSuccess: 'Привязка успешна!',
            passwordModified: 'Пароль успешно изменён',
            languageSwitched: 'Язык изменён на русский'
        },
        navMenu: {
            '53': 'Список уведомлений',
            '131': 'Шаблон печати',
            '159': 'Инициализация шаблона печати',
            '153': 'Настройки столбцов таблицы',
            '132': 'Приоритет данных о затратах труда',
            '52': 'Журнал операций',
            '51': 'Системные параметры',
            '103': 'Управление правилами нумерации',
            '133': 'Системная информация',
            '29': 'Управление заказами прилавка',
            '29000': 'История заказов прилавка',
            '30': 'Управление приёмом',
            '30000': 'История приёма',
            '31': 'Управление выдачей',
            '31000': 'История выдачи',
            '108': 'Возврат клиента',
            '108000': 'История возвратов клиента',
            '109': 'Возврат на завод',
            '109000': 'История возвратов на завод',
            '176': 'Управление закупками и продажами',
            '176000': 'История закупок и продаж',
            '195': 'Расчёт выкупа по цене',
            '195000': 'История расчёта выкупа',
            '198': 'Расчёт продажи по цене',
            '198000': 'История расчёта продажи',
            '187': 'Управление приёмом старых материалов',
            '187000': 'История приёма старых материалов',
            '184': 'Управление отправкой на аффинаж',
            '184000': 'История отправок на аффинаж',
            '186': 'Управление качеством аффинажа',
            '186000': 'История качества аффинажа',
            '185': 'Управление возвратом аффинажа',
            '185000': 'История возврата аффинажа',
            '196': 'Выдача на субподряд',
            '196000': 'История выдач на субподряд',
            '197': 'Приём с субподряда',
            '197000': 'История приёмов с субподряда',
            '214': 'Управление приёмом сырья',
            '214000': 'История приёма сырья',
            '215': 'Управление выдачей сырья',
            '215000': 'История выдачи сырья',
            '147': 'Управление разделением веса',
            '147000': 'История разделения веса',
            '154': 'Приём по штрих-коду',
            '154000': 'История приёма по штрих-коду',
            '165': 'Продажа по штрих-коду',
            '165000': 'История продаж по штрих-коду',
            '166': 'Возврат закупки по штрих-коду',
            '166000': 'История возвратов закупок по штрих-коду',
            '167': 'Возврат продажи по штрих-коду',
            '167000': 'История возвратов продаж по штрих-коду',
            '210': 'Печать этикеток продуктов',
            '155': 'Приём золота и серебра',
            '155000': 'История приёма золота и серебра',
            '156': 'Выдача золота и серебра',
            '156000': 'История выдачи золота и серебра',
            '157': 'Возврат закупки золота и серебра',
            '157000': 'История возвратов закупки золота и серебра',
            '158': 'Возврат продажи золота и серебра',
            '158000': 'История возвратов продажи золота и серебра',
            '161': 'Расчёт перевода золота и серебра',
            '161000': 'История расчёта перевода',
            '32': 'Управление переводами',
            '32000': 'История переводов',
            '33': 'Управление корректировкой запасов',
            '33000': 'История корректировки запасов',
            '148': 'Корректировка информации штрих-кода',
            '148000': 'История корректировки штрих-кодов',
            '150': 'История штрих-кодов',
            '151': 'Инвентаризация по штрих-коду',
            '151000': 'История инвентаризации по штрих-коду',
            '192': 'Управление международной торговлей',
            '193': 'Справочник переработочной торговли',
            '47': 'Сводный отчёт',
            '46': 'Таблица запасов',
            '188': 'Статистика аффинажа металлов',
            '209': 'Статистика субподряда',
            '45': 'Таблица запасов',
            '112': 'Запасы по категориям',
            '212': 'Запасы по номеру продукта',
            '213': 'Детали запасов по номеру',
            '152': 'Запасы по штрих-коду',
            '160': 'Запасы золота и серебра',
            '63': 'Детали заказов',
            '58': 'Детали переводов',
            '146': 'Сводка переводов',
            '48': 'Детали приёма',
            '115': 'Сводка приёма по клиенту',
            '116': 'Сводка приёма по продукту',
            '54': 'Детали выдачи',
            '118': 'Сводка выдачи по клиенту',
            '119': 'Сводка выдачи по продавцу',
            '117': 'Сводка выдачи по продукту',
            '120': 'Детали документов приёма/выдачи',
            '122': 'Детали счетов приёма/выдачи',
            '190': 'Список документов приёма/выдачи',
            '162': 'Сводка затрат труда по продавцу',
            '34': 'Управление расчётом цен',
            '34000': 'История расчёта цен',
            '218': 'Расчёт баланса материалов',
            '218000': 'История расчёта баланса',
            '174': 'Ценообразование металлов',
            '174000': 'История ценообразования',
            '178': 'Расчёт ценообразования',
            '178000': 'История расчёта ценообразования',
            '194': 'Баланс',
            '35': 'Управление взысканием',
            '35000': 'История взыскания',
            '36': 'Управление платежами',
            '36000': 'История платежей',
            '90': 'Управление процентами',
            '38': 'Проводка по счёту',
            '37': 'Корректировка счёта',
            '37000': 'История корректировки счёта',
            '41': 'Корректировка материалов',
            '41000': 'История корректировки материалов',
            '42': 'Корректировка счёта',
            '42000': 'История корректировки счёта',
            '39': 'Конвертация валюты',
            '39000': 'История конвертации валюты',
            '40': 'Конвертация материалов',
            '40000': 'История конвертации материалов',
            '61': 'Сводный отчёт',
            '200': 'Ежедневный отчёт об активах',
            '123': 'Баланс клиента по клиенту',
            '124': 'Баланс клиента по продавцу',
            '125': 'Баланс клиента по продукту',
            '126': 'Выписка клиента по продукту',
            '127': 'Выписка клиента по документу',
            '128': 'Детали доходов и расходов счёта',
            '129': 'Детали расчёта цен',
            '199': 'Сводка расчёта цен по продукту',
            '134': 'Таблица процентов клиента',
            '135': 'Таблица процентов хранения клиента',
            '168': 'Таблица прибыли чистого золота',
            '169': 'Прибыль продаж чистого золота по документу',
            '208': 'Прибыль расчёта продаж чистого золота',
            '211': 'Детали затрат чистого золота',
            '163': 'Таблица затрат труда по штрих-коду',
            '177': 'Таблица прибыли продаж по штрих-коду',
            '164': 'Таблица затрат труда золота и серебра',
            '170': 'Таблица прибыли продаж золота и серебра',
            '205': 'Прибыль продаж по дистрибуции по клиенту',
            '206': 'Прибыль продаж по дистрибуции по продукту',
            '207': 'Прибыль продаж по дистрибуции по документу',
            '179': 'Статистика позиций',
            '189': 'Детали ценообразования',
            '180': 'Детали расчёта ценообразования',
            '182': 'Детали неоплаченного ценообразования',
            '183': 'Сводка неоплаченного ценообразования по продукту',
            '201': 'Сводка неоплаченного ценообразования по клиенту',
            '9': 'Список категорий',
            '10': 'Настройки категорий',
            '114': 'Тип документа',
            '149': 'Управление прилавком',
            '171': 'Управление отделами',
            '172': 'Управление счетами',
            '173': 'Управление типами ценообразования',
            '175': 'План ценообразования металлов',
            '191': 'Управление способами расчёта',
            '11': 'Управление персоналом',
            '14': 'Управление клиентами/поставщиками',
            '121': 'Управление данными продуктов',
            '98': 'Управление магазинами',
            '22': 'Ежедневная цена золота',
            '89': 'Процентная схема',
            '13': 'Список разрешений',
            '67': 'Затраты труда клиента',
            '130': 'Схема затрат труда',
            '92': 'Анализ запасов',
            '102': 'Главная',
            '216': 'Управление проектами расходов',
            '219': 'Управление переводом терминов',
            '220': 'Управление участниками',
            '221': 'Управление тегами участников',
            '222': 'Управление накопленной стоимостью участников',
            '223': 'Отчёт о транзакциях накопленной стоимости участников',
            '224': 'Управление продлением участников',
            '225': 'Управление планами пополнения',
            '226': 'Сборка по штрих-коду',
            '226000': 'История сборки по штрих-коду',
            '227': 'Разборка по штрих-коду',
            '227000': 'История разборки по штрих-коду',
            '228': 'Детальный отчет по рафинации',
            '229': 'Ежедневный отчет по рафинации'
        },
        translationNouns: {
            searchPlaceholder: 'Введите текст поиска',
            index: '№',
            zh_CN: 'Китайский',
            zh_TW: 'Китайский традиционный',
            en: 'Английский',
            ja: 'Японский',
            ko: 'Корейский',
            fr: 'Французский',
            de: 'Немецкий',
            ru: 'Русский',
            ar: 'Арабский',
            ms: 'Малайский',
            vi: 'Вьетнамский',
            th: 'Тайский',
            hi: 'Хинди',
            confirmDelete: 'Вы уверены, что хотите удалить?',
            addSuccess: 'Успешно добавлено',
            deleteSuccess: 'Успешно удалено',
            zh_CNRequired: 'Китайское название обязательно'
        }
    },
    'vi': {
        // Chung
        common: {
            all: 'Tất cả',
            confirm: 'Xác nhận',
            cancel: 'Hủy',
            search: 'Tìm kiếm',
            reset: 'Đặt lại',
            submit: 'Gửi',
            close: 'Đóng',
            back: 'Quay lại',
            refresh: 'Làm mới',
            filter: 'Lọc',
            operation: 'Thao tác',
            success: 'Thành công',
            error: 'Lỗi',
            warning: 'Cảnh báo',
            info: 'Thông tin',
            selectDate: 'Chọn ngày',
            pleaseSelect: 'Vui lòng chọn',
            noData: 'Không có dữ liệu',

            save: 'Lưu',
            add: 'Tạo mới',
            edit: 'Sửa',
            delete: 'Xóa',
            print: 'In',
            audit: 'Kiểm tra',
            cancelAudit: 'Hủy kiểm tra',
            historyBill: 'Lịch sử chứng từ',

            export: 'Xuất',
            import: 'Nhập',
            importDetail: 'Chi tiết nhập',
            electronicScale: 'Cân điện tử',

            creator: 'Người tạo',
            modifier: 'Người sửa',
            createTime: 'Thời gian tạo',
            modifyTime: 'Thời gian sửa',
            auditor: 'Người kiểm tra',
            auditStatus: 'Trạng thái kiểm tra',
            audited: 'Đã kiểm tra',
            notAudited: 'Chưa kiểm tra',
            auditTime: 'Thời gian kiểm tra',

            label: 'Nhãn',
            barcodelabel: 'Nhãn mã vạch',
            diyLabel: 'Nhãn tùy chỉnh',
            rfidLabel: 'RFID',

            productDetail: 'Chi tiết sản phẩm',
            accountDetail: 'Chi tiết tài khoản',
            paymentDetail: 'Chi tiết thanh toán',

            allPriceSettlement: 'Quyết toán tất cả giá',
            allMaterialSettlement: 'Quyết toán tất cả nguyên liệu',
            sequentialPriceSettlement: 'Quyết toán giá tuần tự',
            sequentialMaterialSettlement: 'Quyết toán nguyên liệu tuần tự',

            billNo: 'Số chứng từ',
            billDate: 'Ngày chứng từ',
            billType: 'Loại chứng từ',
            customer: 'Khách hàng',
            counter: 'Quầy',
            salesman: 'Nhân viên bán hàng',
            currency: 'Tiền tệ',
            handler: 'Người xử lý',
            store: 'Cửa hàng',
            remark: 'Ghi chú',

            totalQty: 'Tổng số lượng',
            totalAmt: 'Tổng số tiền',
            priceSettledQty: 'SL quyết toán giá',
            materialSettledQty: 'SL quyết toán nguyên liệu',
            payableAmt: 'Số tiền cần thanh toán',
            unroundedAmt: 'Số tiền chưa làm tròn',
            totalWeight: 'Tổng trọng lượng',
            totalNetGoldWeight: 'Tổng trọng lượng vàng ròng',
            priceSettledWeight: 'Trọng lượng quyết toán giá',
            materialSettledWeight: 'Trọng lượng quyết toán nguyên liệu',
            paidAmt: 'Số tiền đã thanh toán',

            columnConfig: 'Cấu hình cột',
            displayedFields: 'Trường đang hiển thị',
            dragToReorder: 'Kéo để sắp xếp lại các trường',
            optionalFields: 'Trường tùy chọn',
            
            changePassword: 'Đổi mật khẩu',
            oldPassword: 'Mật khẩu cũ',
            newPassword: 'Mật khẩu mới',
            confirmPassword: 'Xác nhận mật khẩu',
            modify: 'Sửa',
            logout: 'Đăng xuất',
            bindWechat: 'Liên kết WeChat',
            
            home: 'Trang chủ',
            marketingManagement: 'Quản lý tiếp thị',
            accountManagement: 'Quản lý tài khoản',
            dataAndSettings: 'Dữ liệu & Cài đặt',
            systemSettings: 'Cài đặt hệ thống',
            productionManagement: 'Quản lý sản xuất',

            closeAll: 'Đóng tất cả',
            closeOther: 'Đóng khác',
            scrollLeft: 'Cuộn trái',
            scrollRight: 'Cuộn phải',

            fullscreen: 'Toàn màn hình',
            exitFullscreen: 'Thoát toàn màn hình',
            unreadMessages: '{count} tin nhắn chưa đọc',
            noUnreadMessages: 'Không có tin nhắn chưa đọc',
            
            bindSuccess: 'Liên kết thành công!',
            passwordModified: 'Đổi mật khẩu thành công',
            languageSwitched: 'Đã chuyển ngôn ngữ sang tiếng Việt'
        },
        navMenu: {
            '53': 'Danh sách thông báo',
            '131': 'Mẫu in',
            '159': 'Khởi tạo mẫu in',
            '153': 'Cài đặt cột bảng',
            '132': 'Ưu tiên dữ liệu công lao động',
            '52': 'Nhật ký thao tác',
            '51': 'Tham số hệ thống',
            '103': 'Quản lý quy tắc số chứng từ',
            '133': 'Thông tin hệ thống',
            '29': 'Quản lý đơn hàng quầy',
            '29000': 'Lịch sử đơn hàng quầy',
            '30': 'Quản lý nhập kho',
            '30000': 'Lịch sử nhập kho',
            '31': 'Quản lý xuất kho',
            '31000': 'Lịch sử xuất kho',
            '108': 'Trả hàng khách',
            '108000': 'Lịch sử trả hàng khách',
            '109': 'Trả hàng nhà máy',
            '109000': 'Lịch sử trả hàng nhà máy',
            '176': 'Quản lý mua bán',
            '176000': 'Lịch sử mua bán',
            '195': 'Quyết toán mua lại giá',
            '195000': 'Lịch sử quyết toán mua lại',
            '198': 'Quyết toán bán giá',
            '198000': 'Lịch sử quyết toán bán',
            '187': 'Quản lý nhập nguyên liệu cũ',
            '187000': 'Lịch sử nhập nguyên liệu cũ',
            '184': 'Quản lý gửi tinh luyện',
            '184000': 'Lịch sử gửi tinh luyện',
            '186': 'Quản lý chất lượng tinh luyện',
            '186000': 'Lịch sử chất lượng tinh luyện',
            '185': 'Quản lý thu hồi tinh luyện',
            '185000': 'Lịch sử thu hồi tinh luyện',
            '196': 'Xuất gia công ngoài',
            '196000': 'Lịch sử xuất gia công ngoài',
            '197': 'Nhập gia công ngoài',
            '197000': 'Lịch sử nhập gia công ngoài',
            '214': 'Quản lý nhập nguyên liệu thô',
            '214000': 'Lịch sử nhập nguyên liệu thô',
            '215': 'Quản lý xuất nguyên liệu thô',
            '215000': 'Lịch sử xuất nguyên liệu thô',
            '147': 'Quản lý phân chia trọng lượng',
            '147000': 'Lịch sử phân chia trọng lượng',
            '154': 'Nhập mã vạch',
            '154000': 'Lịch sử nhập mã vạch',
            '165': 'Xuất bán mã vạch',
            '165000': 'Lịch sử xuất bán mã vạch',
            '166': 'Trả mua mã vạch',
            '166000': 'Lịch sử trả mua mã vạch',
            '167': 'Trả bán mã vạch',
            '167000': 'Lịch sử trả bán mã vạch',
            '210': 'In nhãn sản phẩm',
            '155': 'Nhập vàng bạc',
            '155000': 'Lịch sử nhập vàng bạc',
            '156': 'Xuất vàng bạc',
            '156000': 'Lịch sử xuất vàng bạc',
            '157': 'Trả mua vàng bạc',
            '157000': 'Lịch sử trả mua vàng bạc',
            '158': 'Trả bán vàng bạc',
            '158000': 'Lịch sử trả bán vàng bạc',
            '161': 'Quyết toán chuyển vàng bạc',
            '161000': 'Lịch sử quyết toán chuyển',
            '32': 'Quản lý chuyển kho',
            '32000': 'Lịch sử chuyển kho',
            '33': 'Quản lý điều chỉnh tồn kho',
            '33000': 'Lịch sử điều chỉnh tồn kho',
            '148': 'Điều chỉnh thông tin mã vạch',
            '148000': 'Lịch sử điều chỉnh mã vạch',
            '150': 'Lịch sử mã vạch',
            '151': 'Kiểm kê mã vạch',
            '151000': 'Lịch sử kiểm kê mã vạch',
            '192': 'Quản lý thương mại quốc tế',
            '193': 'Sổ tay thương mại gia công',
            '47': 'Báo cáo tổng hợp',
            '46': 'Bảng tồn kho',
            '188': 'Thống kê tinh luyện kim loại',
            '209': 'Thống kê gia công ngoài',
            '45': 'Bảng tồn kho',
            '112': 'Tồn kho theo danh mục',
            '212': 'Tồn kho theo mã SP',
            '213': 'Chi tiết tồn kho theo mã',
            '152': 'Tồn kho mã vạch',
            '160': 'Tồn kho vàng bạc',
            '63': 'Chi tiết đơn hàng',
            '58': 'Chi tiết chuyển kho',
            '146': 'Tổng hợp chuyển kho',
            '48': 'Chi tiết nhập kho',
            '115': 'Tổng hợp nhập theo khách',
            '116': 'Tổng hợp nhập theo sản phẩm',
            '54': 'Chi tiết xuất kho',
            '118': 'Tổng hợp xuất theo khách',
            '119': 'Tổng hợp xuất theo nhân viên',
            '117': 'Tổng hợp xuất theo sản phẩm',
            '120': 'Chi tiết chứng từ nhập/xuất',
            '122': 'Chi tiết tài khoản nhập/xuất',
            '190': 'Danh sách chứng từ nhập/xuất',
            '162': 'Tổng hợp công lao động theo NV',
            '34': 'Quản lý quyết toán giá',
            '34000': 'Lịch sử quyết toán giá',
            '218': 'Quyết toán tồn nguyên liệu',
            '218000': 'Lịch sử quyết toán tồn',
            '174': 'Định giá kim loại',
            '174000': 'Lịch sử định giá',
            '178': 'Quyết toán định giá',
            '178000': 'Lịch sử quyết toán định giá',
            '194': 'Bảng cân đối',
            '35': 'Quản lý thu tiền',
            '35000': 'Lịch sử thu tiền',
            '36': 'Quản lý chi tiền',
            '36000': 'Lịch sử chi tiền',
            '90': 'Quản lý lãi suất',
            '38': 'Hạch toán tài khoản',
            '37': 'Điều chỉnh tài khoản',
            '37000': 'Lịch sử điều chỉnh tài khoản',
            '41': 'Điều chỉnh nguyên liệu',
            '41000': 'Lịch sử điều chỉnh nguyên liệu',
            '42': 'Điều chỉnh tài khoản',
            '42000': 'Lịch sử điều chỉnh tài khoản',
            '39': 'Chuyển đổi tiền tệ',
            '39000': 'Lịch sử chuyển đổi tiền tệ',
            '40': 'Chuyển đổi nguyên liệu',
            '40000': 'Lịch sử chuyển đổi nguyên liệu',
            '61': 'Báo cáo tổng hợp',
            '200': 'Báo cáo tài sản hàng ngày',
            '123': 'Tồn欠 theo khách',
            '124': 'Tồn欠 theo nhân viên',
            '125': 'Tồn欠 theo sản phẩm',
            '126': 'Đối chiếu theo sản phẩm',
            '127': 'Đối chiếu theo chứng từ',
            '128': 'Chi tiết thu chi tài khoản',
            '129': 'Chi tiết quyết toán giá',
            '199': 'Tổng hợp quyết toán theo SP',
            '134': 'Bảng lãi khách hàng',
            '135': 'Bảng lãi lưu kho',
            '168': 'Bảng lợi nhuận vàng ròng',
            '169': 'Lợi nhuận bán vàng theo chứng từ',
            '208': 'Lợi nhuận quyết toán bán vàng',
            '211': 'Chi tiết chi phí vàng ròng',
            '163': 'Bảng lợi nhuận công lao động mã vạch',
            '177': 'Bảng lợi nhuận bán mã vạch',
            '164': 'Bảng lợi nhuận công vàng bạc',
            '170': 'Bảng lợi nhuận bán vàng bạc',
            '205': 'Lợi nhuận phân phối theo khách',
            '206': 'Lợi nhuận phân phối theo SP',
            '207': 'Lợi nhuận phân phối theo chứng từ',
            '179': 'Thống kê vị thế',
            '189': 'Chi tiết định giá',
            '180': 'Chi tiết quyết toán định giá',
            '182': 'Chi tiết định giá chưa quyết toán',
            '183': 'Tổng hợp chưa quyết toán theo SP',
            '201': 'Tổng hợp chưa quyết toán theo khách',
            '9': 'Danh sách danh mục',
            '10': 'Cài đặt danh mục',
            '114': 'Loại chứng từ',
            '149': 'Quản lý quầy',
            '171': 'Quản lý phòng ban',
            '172': 'Quản lý tài khoản',
            '173': 'Quản lý loại định giá',
            '175': 'Kế hoạch định giá kim loại',
            '191': 'Quản lý phương thức quyết toán',
            '11': 'Quản lý nhân viên',
            '14': 'Quản lý khách/NCC',
            '121': 'Quản lý dữ liệu sản phẩm',
            '98': 'Quản lý cửa hàng',
            '22': 'Giá vàng hàng ngày',
            '89': 'Phương án lãi suất',
            '13': 'Danh sách quyền',
            '67': 'Công lao động khách hàng',
            '130': 'Phương án công lao động',
            '92': 'Phân tích tồn kho',
            '102': 'Trang chủ',
            '216': 'Quản lý dự án chi phí',
            '219': 'Quản lý dịch thuật ngữ',
            '220': 'Quản lý thành viên',
            '221': 'Quản lý thẻ thành viên',
            '222': 'Quản lý giá trị lưu trữ thành viên',
            '223': 'Báo cáo giao dịch giá trị lưu trữ thành viên',
            '224': 'Quản lý gia hạn thành viên',
            '225': 'Quản lý gói giá trị lưu trữ',
            '226': 'Lắp ráp mã vạch',
            '226000': 'Lịch sử lắp ráp mã vạch',
            '227': 'Tháo rời mã vạch',
            '227000': 'Lịch sử tháo rời mã vạch',
            '228': 'Báo cáo chi tiết tinh chế',
            '229': 'Báo cáo hàng ngày tinh chế'
        },
        translationNouns: {
            searchPlaceholder: 'Nhập nội dung tìm kiếm',
            index: 'STT',
            zh_CN: 'Trung Quốc',
            zh_TW: 'Trung Quốc phồn thể',
            en: 'Tiếng Anh',
            ja: 'Tiếng Nhật',
            ko: 'Tiếng Hàn',
            fr: 'Tiếng Pháp',
            de: 'Tiếng Đức',
            ru: 'Tiếng Nga',
            ar: 'Tiếng Ả Rập',
            ms: 'Tiếng Mã Lai',
            vi: 'Tiếng Việt',
            th: 'Tiếng Thái',
            hi: 'Tiếng Hindi',
            confirmDelete: 'Bạn có chắc chắn muốn xóa?',
            addSuccess: 'Thêm thành công',
            deleteSuccess: 'Xóa thành công',
            zh_CNRequired: 'Danh từ Trung Quốc là bắt buộc'
        }
    },
    'th': {
        // ทั่วไป
        common: {
            all: 'ทั้งหมด',
            confirm: 'ยืนยัน',
            cancel: 'ยกเลิก',
            search: 'ค้นหา',
            reset: 'รีเซ็ต',
            submit: 'ส่ง',
            close: 'ปิด',
            back: 'กลับ',
            refresh: 'รีเฟรช',
            filter: 'กรอง',
            operation: 'การดำเนินการ',
            success: 'สำเร็จ',
            error: 'ข้อผิดพลาด',
            warning: 'คำเตือน',
            info: 'ข้อมูล',
            selectDate: 'เลือกวันที่',
            pleaseSelect: 'กรุณาเลือก',
            noData: 'ไม่มีข้อมูล',

            save: 'บันทึก',
            add: 'สร้างใหม่',
            edit: 'แก้ไข',
            delete: 'ลบ',
            print: 'พิมพ์',
            audit: 'ตรวจสอบ',
            cancelAudit: 'ยกเลิกการตรวจสอบ',
            historyBill: 'ประวัติเอกสาร',

            export: 'ส่งออก',
            import: 'นำเข้า',
            importDetail: 'รายละเอียดนำเข้า',
            electronicScale: 'เครื่องชั่งอิเล็กทรอนิกส์',

            creator: 'ผู้สร้าง',
            modifier: 'ผู้แก้ไข',
            createTime: 'เวลาสร้าง',
            modifyTime: 'เวลาแก้ไข',
            auditor: 'ผู้ตรวจสอบ',
            auditStatus: 'สถานะการตรวจสอบ',
            audited: 'ตรวจสอบแล้ว',
            notAudited: 'ยังไม่ได้ตรวจสอบ',
            auditTime: 'เวลาตรวจสอบ',

            label: 'ป้าย',
            barcodelabel: 'ป้ายบาร์โค้ด',
            diyLabel: 'ป้ายกำหนดเอง',
            rfidLabel: 'RFID',

            productDetail: 'รายละเอียดสินค้า',
            accountDetail: 'รายละเอียดบัญชี',
            paymentDetail: 'รายละเอียดการชำระเงิน',

            allPriceSettlement: 'สรุปราคาทั้งหมด',
            allMaterialSettlement: 'สรุปวัสดุทั้งหมด',
            sequentialPriceSettlement: 'สรุปราคาตามลำดับ',
            sequentialMaterialSettlement: 'สรุปวัสดุตามลำดับ',

            billNo: 'เลขที่เอกสาร',
            billDate: 'วันที่เอกสาร',
            billType: 'ประเภทเอกสาร',
            customer: 'ลูกค้า',
            counter: 'เคาน์เตอร์',
            salesman: 'พนักงานขาย',
            currency: 'สกุลเงิน',
            handler: 'ผู้ดำเนินการ',
            store: 'ร้านค้า',
            remark: 'หมายเหตุ',

            totalQty: 'จำนวนรวม',
            totalAmt: 'จำนวนเงินรวม',
            priceSettledQty: 'จำนวนสรุปราคา',
            materialSettledQty: 'จำนวนสรุปวัสดุ',
            payableAmt: 'จำนวนเงินที่ต้องชำระ',
            unroundedAmt: 'จำนวนเงินที่ยังไม่ปัดเศษ',
            totalWeight: 'น้ำหนักรวม',
            totalNetGoldWeight: 'น้ำหนักทองคำบริสุทธิ์รวม',
            priceSettledWeight: 'น้ำหนักสรุปราคา',
            materialSettledWeight: 'น้ำหนักสรุปวัสดุ',
            paidAmt: 'จำนวนเงินที่ชำระแล้ว',

            columnConfig: 'การตั้งค่าคอลัมน์',
            displayedFields: 'ฟิลด์ที่แสดง',
            dragToReorder: 'ลากเพื่อจัดเรียงฟิลด์ใหม่',
            optionalFields: 'ฟิลด์ทางเลือก',
            
            changePassword: 'เปลี่ยนรหัสผ่าน',
            oldPassword: 'รหัสผ่านเก่า',
            newPassword: 'รหัสผ่านใหม่',
            confirmPassword: 'ยืนยันรหัสผ่าน',
            modify: 'แก้ไข',
            logout: 'ออกจากระบบ',
            bindWechat: 'เชื่อมโยง WeChat',
            
            home: 'หน้าแรก',
            marketingManagement: 'การจัดการการตลาด',
            accountManagement: 'การจัดการบัญชี',
            dataAndSettings: 'ข้อมูลและการตั้งค่า',
            systemSettings: 'ตั้งค่าระบบ',
            productionManagement: 'การจัดการการผลิต',

            closeAll: 'ปิดทั้งหมด',
            closeOther: 'ปิดอื่นๆ',
            scrollLeft: 'เลื่อนซ้าย',
            scrollRight: 'เลื่อนขวา',

            fullscreen: 'เต็มหน้าจอ',
            exitFullscreen: 'ออกจากเต็มหน้าจอ',
            unreadMessages: '{count} ข้อความที่ยังไม่ได้อ่าน',
            noUnreadMessages: 'ไม่มีข้อความที่ยังไม่ได้อ่าน',
            
            bindSuccess: 'เชื่อมโยงสำเร็จ!',
            passwordModified: 'เปลี่ยนรหัสผ่านสำเร็จ',
            languageSwitched: 'เปลี่ยนภาษาเป็นภาษาไทยแล้ว'
        },
        navMenu: {
            '53': 'รายการแจ้งเตือน',
            '131': 'แม่แบบพิมพ์',
            '159': 'เริ่มต้นแม่แบบพิมพ์',
            '153': 'ตั้งค่าคอลัมน์ตาราง',
            '132': 'ลำดับความสำคัญข้อมูลค่าแรง',
            '52': 'บันทึกการดำเนินการ',
            '51': 'พารามิเตอร์ระบบ',
            '103': 'จัดการกฎเลขที่เอกสาร',
            '133': 'ข้อมูลระบบ',
            '29': 'จัดการคำสั่งซื้อเคาน์เตอร์',
            '29000': 'ประวัติคำสั่งซื้อเคาน์เตอร์',
            '30': 'จัดการสินค้าเข้า',
            '30000': 'ประวัติสินค้าเข้า',
            '31': 'จัดการสินค้าออก',
            '31000': 'ประวัติสินค้าออก',
            '108': 'ลูกค้าคืนสินค้า',
            '108000': 'ประวัติลูกค้าคืนสินค้า',
            '109': 'คืนโรงงาน',
            '109000': 'ประวัติคืนโรงงาน',
            '176': 'จัดการซื้อและขาย',
            '176000': 'ประวัติซื้อและขาย',
            '195': 'สรุปการซื้อคืนตามราคา',
            '195000': 'ประวัติสรุปการซื้อคืน',
            '198': 'สรุปการขายตามราคา',
            '198000': 'ประวัติสรุปการขาย',
            '187': 'จัดการวัสดุเก่าเข้า',
            '187000': 'ประวัติวัสดุเก่าเข้า',
            '184': 'จัดการส่งถลุง',
            '184000': 'ประวัติส่งถลุง',
            '186': 'จัดการคุณภาพถลุง',
            '186000': 'ประวัติคุณภาพถลุง',
            '185': 'จัดการกู้คืนถลุง',
            '185000': 'ประวติกู้คืนถลุง',
            '196': 'ส่งออกจ้างผลิต',
            '196000': 'ประวัติส่งออกจ้างผลิต',
            '197': 'นำเข้าจ้างผลิต',
            '197000': 'ประวัตินำเข้าจ้างผลิต',
            '214': 'จัดการวัตถุดิบเข้า',
            '214000': 'ประวัติวัตถุดิบเข้า',
            '215': 'จัดการวัตถุดิบออก',
            '215000': 'ประวัติวัตถุดิบออก',
            '147': 'จัดการแบ่งน้ำหนัก',
            '147000': 'ประวัติแบ่งน้ำหนัก',
            '154': 'บาร์โค้ดเข้า',
            '154000': 'ประวัติบาร์โค้ดเข้า',
            '165': 'ขายบาร์โค้ดออก',
            '165000': 'ประวัติขายบาร์โค้ดออก',
            '166': 'คืนซื้อบาร์โค้ด',
            '166000': 'ประวัติคืนซื้อบาร์โค้ด',
            '167': 'คืนขายบาร์โค้ด',
            '167000': 'ประวัติคืนขายบาร์โค้ด',
            '210': 'พิมพ์ป้ายสินค้า',
            '155': 'ทองเงินเข้า',
            '155000': 'ประวัติทองเงินเข้า',
            '156': 'ทองเงินออก',
            '156000': 'ประวัติทองเงินออก',
            '157': 'คืนซื้อทองเงิน',
            '157000': 'ประวัติคืนซื้อทองเงิน',
            '158': 'คืนขายทองเงิน',
            '158000': 'ประวัติคืนขายทองเงิน',
            '161': 'สรุปโอนทองเงิน',
            '161000': 'ประวัติสรุปโอน',
            '32': 'จัดการโอน',
            '32000': 'ประวัติโอน',
            '33': 'จัดการปรับสต็อก',
            '33000': 'ประวัติปรับสต็อก',
            '148': 'ปรับข้อมูลบาร์โค้ด',
            '148000': 'ประวัติปรับบาร์โค้ด',
            '150': 'ประวัติบาร์โค้ด',
            '151': 'นับสต็อกบาร์โค้ด',
            '151000': 'ประวัตินับสต็อกบาร์โค้ด',
            '192': 'จัดการการค้าระหว่างประเทศ',
            '193': 'คู่มือการค้าแปรรูป',
            '47': 'รายงานสรุป',
            '46': 'ตารางสต็อก',
            '188': 'สถิติถลุงโลหะ',
            '209': 'สถิติจ้างผลิต',
            '45': 'ตารางสต็อก',
            '112': 'สต็อกตามหมวด',
            '212': 'สต็อกตามรหัสสินค้า',
            '213': 'รายละเอียดสต็อกตามรหัส',
            '152': 'สต็อกบาร์โค้ด',
            '160': 'สต็อกทองเงิน',
            '63': 'รายละเอียดคำสั่งซื้อ',
            '58': 'รายละเอียดโอน',
            '146': 'สรุปโอน',
            '48': 'รายละเอียดสินค้าเข้า',
            '115': 'สรุปเข้าตามลูกค้า',
            '116': 'สรุปเข้าตามสินค้า',
            '54': 'รายละเอียดสินค้าออก',
            '118': 'สรุปออกตามลูกค้า',
            '119': 'สรุปออกตามพนักงานขาย',
            '117': 'สรุปออกตามสินค้า',
            '120': 'รายละเอียดเอกสารเข้า/ออก',
            '122': 'รายละเอียดบัญชีเข้า/ออก',
            '190': 'รายการเอกสารเข้า/ออก',
            '162': 'สรุปค่าแรงตามพนักงานขาย',
            '34': 'จัดการสรุปราคา',
            '34000': 'ประวัติสรุปราคา',
            '218': 'สรุปยอดคงเหลือวัสดุ',
            '218000': 'ประวัติสรุปยอดคงเหลือ',
            '174': 'กำหนดราคาโลหะ',
            '174000': 'ประวัติกำหนดราคา',
            '178': 'สรุปกำหนดราคา',
            '178000': 'ประวัติสรุปกำหนดราคา',
            '194': 'งบดุล',
            '35': 'จัดการรับเงิน',
            '35000': 'ประวัติรับเงิน',
            '36': 'จัดการจ่ายเงิน',
            '36000': 'ประวัติจ่ายเงิน',
            '90': 'จัดการดอกเบี้ย',
            '38': 'ลงบัญชี',
            '37': 'ปรับบัญชี',
            '37000': 'ประวัติปรับบัญชี',
            '41': 'ปรับวัสดุ',
            '41000': 'ประวัติปรับวัสดุ',
            '42': 'ปรับบัญชี',
            '42000': 'ประวัติปรับบัญชี',
            '39': 'แปลงสกุลเงิน',
            '39000': 'ประวัติแปลงสกุลเงิน',
            '40': 'แปลงวัสดุ',
            '40000': 'ประวัติแปลงวัสดุ',
            '61': 'รายงานสรุป',
            '200': 'รายงานทรัพย์สินรายวัน',
            '123': 'ยอดคงเหลือตามลูกค้า',
            '124': 'ยอดคงเหลือตามพนักงานขาย',
            '125': 'ยอดคงเหลือตามสินค้า',
            '126': 'ใบแจ้งหนี้ตามสินค้า',
            '127': 'ใบแจ้งหนี้ตามเอกสาร',
            '128': 'รายละเอียดรับจ่ายบัญชี',
            '129': 'รายละเอียดสรุปราคา',
            '199': 'สรุปสรุปราคาตามสินค้า',
            '134': 'ตารางดอกเบี้ยลูกค้า',
            '135': 'ตารางดอกเบี้ยคลัง',
            '168': 'ตารางกำไรทองคำบริสุทธิ์',
            '169': 'กำไรขายทองตามเอกสาร',
            '208': 'กำไรสรุปขายทอง',
            '211': 'รายละเอียดต้นทุนทอง',
            '163': 'ตารางกำไรค่าแรงบาร์โค้ด',
            '177': 'ตารางกำไรขายบาร์โค้ด',
            '164': 'ตารางกำไรค่าแรงทองเงิน',
            '170': 'ตารางกำไรขายทองเงิน',
            '205': 'กำไรจัดจำหน่ายตามลูกค้า',
            '206': 'กำไรจัดจำหน่ายตามสินค้า',
            '207': 'กำไรจัดจำหน่ายตามเอกสาร',
            '179': 'สถิติตำแหน่ง',
            '189': 'รายละเอียดกำหนดราคา',
            '180': 'รายละเอียดสรุปกำหนดราคา',
            '182': 'รายละเอียดกำหนดราคาที่ยังไม่สรุป',
            '183': 'สรุปยังไม่สรุปตามสินค้า',
            '201': 'สรุปยังไม่สรุปตามลูกค้า',
            '9': 'รายการหมวดหมู่',
            '10': 'ตั้งค่าหมวดหมู่',
            '114': 'ประเภทเอกสาร',
            '149': 'จัดการเคาน์เตอร์',
            '171': 'จัดการแผนก',
            '172': 'จัดการบัญชี',
            '173': 'จัดการประเภทกำหนดราคา',
            '175': 'แผนกำหนดราคาโลหะ',
            '191': 'จัดการวิธีสรุป',
            '11': 'จัดการพนักงาน',
            '14': 'จัดการลูกค้า/ผู้ขาย',
            '121': 'จัดการข้อมูลสินค้า',
            '98': 'จัดการร้านค้า',
            '22': 'ราคาทองรายวัน',
            '89': 'แผนดอกเบี้ย',
            '13': 'รายการสิทธิ์',
            '67': 'ค่าแรงลูกค้า',
            '130': 'แผนค่าแรง',
            '92': 'วิเคราะห์สต็อก',
            '102': 'หน้าแรก',
            '216': 'จัดการโครงการค่าใช้จ่าย',
            '219': 'จัดการแปลศัพท์',
            '220': 'จัดการสมาชิก',
            '221': 'จัดการแท็กสมาชิก',
            '222': 'จัดการมูลค่าที่เก็บของสมาชิก',
            '223': 'รายงานธุรกรรมมูลค่าที่เก็บของสมาชิก',
            '224': 'จัดการต่ออายุสมาชิก',
            '225': 'การจัดการแผนมูลค่าที่เก็บไว้',
            '226': 'ประกอบบาร์โค้ด',
            '226000': 'ประวัติการประกอบบาร์โค้ด',
            '227': 'ถอดบาร์โค้ด',
            '227000': 'ประวัติการถอดบาร์โค้ด',
            '228': 'รายละเอียดการชำระล้าง',
            '229': 'รายงานรายวันการชำระล้าง'
        },
        translationNouns: {
            searchPlaceholder: 'ป้อนเนื้อหาการค้นหา',
            index: 'ลำดับ',
            zh_CN: 'จีน',
            zh_TW: 'จีนตัวเต็ม',
            en: 'อังกฤษ',
            ja: 'ญี่ปุ่น',
            ko: 'เกาหลี',
            fr: 'ฝรั่งเศส',
            de: 'เยอรมัน',
            ru: 'รัสเซีย',
            ar: 'อาหรับ',
            ms: 'มลายู',
            vi: 'เวียดนาม',
            th: 'ไทย',
            hi: 'ฮินดี',
            confirmDelete: 'คุณแน่ใจหรือไม่ว่าต้องการลบ?',
            addSuccess: 'เพิ่มสำเร็จ',
            deleteSuccess: 'ลบสำเร็จ',
            zh_CNRequired: 'คำนามภาษาจีนจำเป็นต้องกรอก'
        }
    },
    'hi': {
        // सामान्य
        common: {
            all: 'सभी',
            confirm: 'पुष्टि',
            cancel: 'रद्द',
            search: 'खोज',
            reset: 'रीसेट',
            submit: 'जमा',
            close: 'बंद',
            back: 'वापस',
            refresh: 'रीफ्रेश',
            filter: 'फ़िल्टर',
            operation: 'ऑपरेशन',
            success: 'सफल',
            error: 'त्रुटि',
            warning: 'चेतावनी',
            info: 'सूचना',
            selectDate: 'तारीख चुनें',
            pleaseSelect: 'कृपया चुनें',
            noData: 'कोई डेटा नहीं',

            save: 'सहेजें',
            add: 'नया बनाएं',
            edit: 'संपादित',
            delete: 'हटाएं',
            print: 'प्रिंट',
            audit: 'जांच',
            cancelAudit: 'जांच रद्द',
            historyBill: 'दस्तावेज़ इतिहास',

            export: 'निर्यात',
            import: 'आयात',
            importDetail: 'आयात विवरण',
            electronicScale: 'इलेक्ट्रॉनिक तराज़ू',

            creator: 'निर्माता',
            modifier: 'संपादक',
            createTime: 'निर्माण समय',
            modifyTime: 'संपादन समय',
            auditor: 'जांचकर्ता',
            auditStatus: 'जांच स्थिति',
            audited: 'जांचित',
            notAudited: 'अजांचित',
            auditTime: 'जांच समय',

            label: 'लेबल',
            barcodelabel: 'बारकोड लेबल',
            diyLabel: 'कस्टम लेबल',
            rfidLabel: 'RFID',

            productDetail: 'उत्पाद विवरण',
            accountDetail: 'खाता विवरण',
            paymentDetail: 'भुगतान विवरण',

            allPriceSettlement: 'सभी मूल्य निपटान',
            allMaterialSettlement: 'सभी सामग्री निपटान',
            sequentialPriceSettlement: 'क्रमिक मूल्य निपटान',
            sequentialMaterialSettlement: 'क्रमिक सामग्री निपटान',

            billNo: 'दस्तावेज़ संख्या',
            billDate: 'दस्तावेज़ तिथि',
            billType: 'दस्तावेज़ प्रकार',
            customer: 'ग्राहक',
            counter: 'काउंटर',
            salesman: 'विक्रेता',
            currency: 'मुद्रा',
            handler: 'प्रबंधक',
            store: 'दुकान',
            remark: 'टिप्पणी',

            totalQty: 'कुल मात्रा',
            totalAmt: 'कुल राशि',
            priceSettledQty: 'मूल्य निपटान मात्रा',
            materialSettledQty: 'सामग्री निपटान मात्रा',
            payableAmt: 'देय राशि',
            unroundedAmt: 'अगोलित राशि',
            totalWeight: 'कुल वज़न',
            totalNetGoldWeight: 'कुल शुद्ध सोना वज़न',
            priceSettledWeight: 'मूल्य निपटान वज़न',
            materialSettledWeight: 'सामग्री निपटान वज़न',
            paidAmt: 'भुगतान राशि',

            columnConfig: 'कॉलम कॉन्फ़िगरेशन',
            displayedFields: 'प्रदर्शित फ़ील्ड',
            dragToReorder: 'फ़ील्ड पुनर्व्यवस्थित करने के लिए खींचें',
            optionalFields: 'वैकल्पिक फ़ील्ड',
            
            changePassword: 'पासवर्ड बदलें',
            oldPassword: 'पुराना पासवर्ड',
            newPassword: 'नया पासवर्ड',
            confirmPassword: 'पासवर्ड पुष्टि',
            modify: 'संपादित',
            logout: 'लॉग आउट',
            bindWechat: 'WeChat बांधें',
            
            home: 'होम',
            marketingManagement: 'विपणन प्रबंधन',
            accountManagement: 'खाता प्रबंधन',
            dataAndSettings: 'डेटा और सेटिंग्स',
            systemSettings: 'सिस्टम सेटिंग्स',
            productionManagement: 'उत्पादन प्रबंधन',

            closeAll: 'सभी बंद',
            closeOther: 'अन्य बंद',
            scrollLeft: 'बाएं स्क्रॉल',
            scrollRight: 'दाएं स्क्रॉल',

            fullscreen: 'पूर्ण स्क्रीन',
            exitFullscreen: 'पूर्ण स्क्रीन बंद',
            unreadMessages: '{count} अपठित संदेश',
            noUnreadMessages: 'कोई अपठित संदेश नहीं',
            
            bindSuccess: 'बांधने में सफल!',
            passwordModified: 'पासवर्ड सफलतापूर्वक बदला',
            languageSwitched: 'भाषा हिंदी में बदली गई'
        },
        navMenu: {
            '53': 'सूचना सूची',
            '131': 'प्रिंट टेम्पलेट',
            '159': 'प्रिंट टेम्पलेट प्रारंभ',
            '153': 'टेबल कॉलम सेटिंग',
            '132': 'श्रम लागत डेटा प्राथमिकता',
            '52': 'ऑपरेशन लॉग',
            '51': 'सिस्टम पैरामीटर',
            '103': 'दस्तावेज़ संख्या नियम प्रबंधन',
            '133': 'सिस्टम जानकारी',
            '29': 'काउंटर ऑर्डर प्रबंधन',
            '29000': 'काउंटर ऑर्डर इतिहास',
            '30': 'अंदर प्रबंधन',
            '30000': 'अंदर इतिहास',
            '31': 'बाहर प्रबंधन',
            '31000': 'बाहर इतिहास',
            '108': 'ग्राहक वापसी',
            '108000': 'ग्राहक वापसी इतिहास',
            '109': 'कारखाना वापसी',
            '109000': 'कारखाना वापसी इतिहास',
            '176': 'खरीद और बिक्री प्रबंधन',
            '176000': 'खरीद बिक्री इतिहास',
            '195': 'मूल्य पुनर्खरीद निपटान',
            '195000': 'मूल्य पुनर्खरीद निपटान इतिहास',
            '198': 'मूल्य बिक्री निपटान',
            '198000': 'मूल्य बिक्री निपटान इतिहास',
            '187': 'पुरानी सामग्री अंदर प्रबंधन',
            '187000': 'पुरानी सामग्री अंदर इतिहास',
            '184': 'शोधन भेज प्रबंधन',
            '184000': 'शोधन भेज इतिहास',
            '186': 'शोधन गुणवत्ता प्रबंधन',
            '186000': 'शोधन गुणवत्ता इतिहास',
            '185': 'शोधन वसूली प्रबंधन',
            '185000': 'शोधन वसूली इतिहास',
            '196': 'आउटसोर्सिंग बाहर',
            '196000': 'आउटसोर्सिंग बाहर इतिहास',
            '197': 'आउटसोर्सिंग अंदर',
            '197000': 'आउटसोर्सिंग अंदर इतिहास',
            '214': 'कच्चा माल अंदर प्रबंधन',
            '214000': 'कच्चा माल अंदर इतिहास',
            '215': 'कच्चा माल बाहर प्रबंधन',
            '215000': 'कच्चा माल बाहर इतिहास',
            '147': 'वज़न विभाजन प्रबंधन',
            '147000': 'वज़न विभाजन इतिहास',
            '154': 'बारकोड अंदर',
            '154000': 'बारकोड अंदर इतिहास',
            '165': 'बारकोड बिक्री बाहर',
            '165000': 'बारकोड बिक्री बाहर इतिहास',
            '166': 'बारकोड खरीद वापसी',
            '166000': 'बारकोड खरीद वापसी इतिहास',
            '167': 'बारकोड बिक्री वापसी',
            '167000': 'बारकोड बिक्री वापसी इतिहास',
            '210': 'उत्पाद लेबल प्रिंट',
            '155': 'सोना चांदी अंदर',
            '155000': 'सोना चांदी अंदर इतिहास',
            '156': 'सोना चांदी बाहर',
            '156000': 'सोना चांदी बाहर इतिहास',
            '157': 'सोना चांदी खरीद वापसी',
            '157000': 'सोना चांदी खरीद वापसी इतिहास',
            '158': 'सोना चांदी बिक्री वापसी',
            '158000': 'सोना चांदी बिक्री वापसी इतिहास',
            '161': 'सोना चांदी हस्तांतरण निपटान',
            '161000': 'सोना चांदी हस्तांतरण निपटान इतिहास',
            '32': 'हस्तांतरण प्रबंधन',
            '32000': 'हस्तांतरण इतिहास',
            '33': 'स्टॉक समायोजन प्रबंधन',
            '33000': 'स्टॉक समायोजन इतिहास',
            '148': 'बारकोड जानकारी समायोजन',
            '148000': 'बारकोड समायोजन इतिहास',
            '150': 'बारकोड इतिहास',
            '151': 'बारकोड स्टॉक गणना',
            '151000': 'बारकोड स्टॉक गणना इतिहास',
            '192': 'अंतर्राष्ट्रीय व्यापार प्रबंधन',
            '193': 'प्रसंस्करण व्यापार मैनुअल',
            '47': 'व्यापक रिपोर्ट',
            '46': 'स्टॉक तालिका',
            '188': 'धातु शोधन सांख्यिकी',
            '209': 'आउटसोर्सिंग सांख्यिकी',
            '45': 'स्टॉक तालिका',
            '112': 'श्रेणी अनुसार स्टॉक',
            '212': 'उत्पाद संख्या स्टॉक',
            '213': 'उत्पाद संख्या स्टॉक विवरण',
            '152': 'बारकोड स्टॉक',
            '160': 'सोना चांदी स्टॉक',
            '63': 'ऑर्डर विवरण',
            '58': 'हस्तांतरण विवरण',
            '146': 'हस्तांतरण सारांश',
            '48': 'अंदर विवरण',
            '115': 'ग्राहक अनुसार अंदर सारांश',
            '116': 'उत्पाद अनुसार अंदर सारांश',
            '54': 'बाहर विवरण',
            '118': 'ग्राहक अनुसार बाहर सारांश',
            '119': 'विक्रेता अनुसार बाहर सारांश',
            '117': 'उत्पाद अनुसार बाहर सारांश',
            '120': 'अंदर/बाहर दस्तावेज़ विवरण',
            '122': 'अंदर/बाहर खाता विवरण',
            '190': 'अंदर/बाहर दस्तावेज़ सूची',
            '162': 'विक्रेता अनुसार श्रम लागत सारांश',
            '34': 'मूल्य निपटान प्रबंधन',
            '34000': 'मूल्य निपटान इतिहास',
            '218': 'सामग्री शेष निपटान',
            '218000': 'सामग्री शेष निपटान इतिहास',
            '174': 'धातु मूल्य निर्धारण',
            '174000': 'धातु मूल्य निर्धारण इतिहास',
            '178': 'धातु मूल्य निपटान',
            '178000': 'धातु मूल्य निपटान इतिहास',
            '194': '_balance शीट',
            '35': 'प्राप्ति प्रबंधन',
            '35000': 'प्राप्ति इतिहास',
            '36': 'भुगतान प्रबंधन',
            '36000': 'भुगतान इतिहास',
            '90': 'ब्याज प्रबंधन',
            '38': 'खाता पोस्टिंग',
            '37': 'खाता समायोजन',
            '37000': 'खाता समायोजन इतिहास',
            '41': 'सामग्री समायोजन',
            '41000': 'सामग्री समायोजन इतिहास',
            '42': 'खाता समायोजन',
            '42000': 'खाता समायोजन इतिहास',
            '39': 'मुद्रा रूपांतरण',
            '39000': 'मुद्रा रूपांतरण इतिहास',
            '40': 'सामग्री रूपांतरण',
            '40000': 'सामग्री रूपांतरण इतिहास',
            '61': 'व्यापक रिपोर्ट',
            '200': 'दैनिक संपत्ति रिपोर्ट',
            '123': 'ग्राहक अनुसार शेष',
            '124': 'विक्रेता अनुसार शेष',
            '125': 'उत्पाद अनुसार शेष',
            '126': 'उत्पाद अनुसार विवरण',
            '127': 'दस्तावेज़ अनुसार विवरण',
            '128': 'खाता आय/व्यय विवरण',
            '129': 'मूल्य निपटान विवरण',
            '199': 'उत्पाद अनुसार मूल्य निपटान सारांश',
            '134': 'ग्राहक ब्याज तालिका',
            '135': 'ग्राहक भंडारण ब्याज तालिका',
            '168': 'शुद्ध सोना लाभ तालिका',
            '169': 'दस्तावेज़ अनुसार सोना बिक्री लाभ',
            '208': 'सोना बिक्री निपटान लाभ',
            '211': 'शुद्ध सोना लागत विवरण',
            '163': 'बारकोड श्रम लाभ तालिका',
            '177': 'बारकोड बिक्री लाभ तालिका',
            '164': 'सोना चांदी श्रम लाभ तालिका',
            '170': 'सोना चांदी बिक्री लाभ तालिका',
            '205': 'ग्राहक अनुसार वितरण लाभ',
            '206': 'उत्पाद अनुसार वितरण लाभ',
            '207': 'दस्तावेज़ अनुसार वितरण लाभ',
            '179': 'स्थिति सांख्यिकी',
            '189': 'मूल्य निर्धारण विवरण',
            '180': 'मूल्य निर्धारण निपटान विवरण',
            '182': 'अनिपटान मूल्य निर्धारण विवरण',
            '183': 'उत्पाद अनुसार अनिपटान सारांश',
            '201': 'ग्राहक अनुसार अनिपटान सारांश',
            '9': 'श्रेणी सूची',
            '10': 'श्रेणी सेटिंग',
            '114': 'दस्तावेज़ प्रकार',
            '149': 'काउंटर प्रबंधन',
            '171': 'विभाग प्रबंधन',
            '172': 'खाता प्रबंधन',
            '173': 'मूल्य निर्धारण प्रकार प्रबंधन',
            '175': 'धातु मूल्य निर्धारण योजना',
            '191': 'निपटान विधि प्रबंधन',
            '11': 'कर्मचारी प्रबंधन',
            '14': 'ग्राहक/आपूर्तिकर्ता प्रबंधन',
            '121': 'उत्पाद डेटा प्रबंधन',
            '98': 'दुकान प्रबंधन',
            '22': 'दैनिक सोना मूल्य',
            '89': 'ब्याज योजना',
            '13': 'अनुमति सूची',
            '67': 'ग्राहक श्रम लागत',
            '130': 'श्रम लागत योजना',
            '92': 'स्टॉक विश्लेषण',
            '102': 'होम',
            '216': 'व्यय परियोजना प्रबंधन',
            '219': 'शब्दावली अनुवाद प्रबंधन',
            '220': 'सदस्य प्रबंधन',
            '221': 'सदस्य टैग प्रबंधन',
            '222': 'सदस्य संचित मूल्य प्रबंधन',
            '223': 'सदस्य संचित मूल्य लेनदेन रिपोर्ट',
            '224': 'सदस्य नवीनीकरण प्रबंधन',
            '225': 'संग्रहीत मूल्य योजना प्रबंधन',
            '226': 'बारकोड असेंबली',
            '226000': 'बारकोड असेंबली इतिहास',
            '227': 'बारकोड डिस्सेम्बली',
            '227000': 'बारकोड डिस्सेम्बली इतिहास',
            '228': 'शुद्धीकरण विवरण रिपोर्ट',
            '229': 'शुद्धीकरण दैनिक रिपोर्ट'
        },
        translationNouns: {
            searchPlaceholder: 'खोज सामग्री दर्ज करें',
            index: 'क्रमांक',
            zh_CN: 'चीनी',
            zh_TW: 'चीनी पारंपरिक',
            en: 'अंग्रेजी',
            ja: 'जापानी',
            ko: 'कोरियाई',
            fr: 'फ्रांसीसी',
            de: 'जर्मन',
            ru: 'रूसी',
            ar: 'अरबी',
            ms: 'मलय',
            vi: 'वियतनामी',
            th: 'थाई',
            hi: 'हिंदी',
            confirmDelete: 'क्या आप सुनिश्चित हैं कि हटाना है?',
            addSuccess: 'सफलतापूर्वक जोड़ा गया',
            deleteSuccess: 'सफलतापूर्वक हटाया गया',
            zh_CNRequired: 'चीनी नाम आवश्यक है'
        }
    }
}